/*!
 * 
 *
 * 	This file is auto generated by webpack.
 * 	Do not edit this file directly.
 *
 *
 */
/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 243:
/***/ (function() {

"use strict";

// UNUSED EXPORTS: default

;// ./js/helpers/sectionClass.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var sectionClass = function (_HTMLElement) {
  function sectionClass(name, id) {
    var _this;
    _classCallCheck(this, sectionClass);
    _this = _callSuper(this, sectionClass);
    _defineProperty(_this, "initElements", function () {
      var _this2 = this;
      this.elements = this.querySelectorAll('[id]');
      var self = this;
      this.elements.forEach(function (element) {
        element.refresh = function () {
          self.refresh(element.id);
        };
        _this2[element.id] = element;
      });
    });
    _defineProperty(_this, "refresh", function (elementID, productUrl) {
      var _this3 = this;
      var fetchUrl = productUrl || window.location.pathname;
      fetch("".concat(fetchUrl, "?section_id=").concat(this.id)).then(function (res) {
        return res.text();
      }).then(function (htmlString) {
        var trimmedHtml = htmlString.trim();
        if (!trimmedHtml || trimmedHtml === '' || trimmedHtml.length === 0) {
          _this3.dispatchEvent(new CustomEvent('section:empty', {
            detail: {
              sectionId: _this3.id
            }
          }));
          _this3.onRefreshFinish(null);
          return;
        }
        var newDom = document.createElement('div');
        if (elementID) {
          var element = _this3.sectionElement.querySelector('#' + elementID);
          newDom.innerHTML = trimmedHtml;
          newDom = newDom.querySelector('#' + elementID);
          if (newDom && element) {
            element.parentNode.replaceChild(newDom, element);
          }
        } else {
          newDom.innerHTML = trimmedHtml;
          var sectionElement = newDom.querySelector('#' + _this3.id);
          if (sectionElement) {
            _this3.innerHTML = sectionElement.innerHTML;
          }
        }
        _this3.initElements();
        _this3.onRefreshFinish(newDom);
      }).catch(function (error) {
        console.error("[".concat(_this3.constructor.name, "] Error refreshing section ").concat(_this3.id, ":"), error);
        _this3.dispatchEvent(new CustomEvent('section:error', {
          detail: {
            sectionId: _this3.id,
            error: error
          }
        }));
      });
    });
    if (!window.sections) {
      window.sections = [];
    }
    if (window.sections[name]) {
      if (window.sections[name].id == _this.id) {} else if (Array.isArray(window.sections[name])) {
        window.sections[name] = [].concat(_toConsumableArray(window.sections[name]), [_this]);
      } else {
        window.sections[name] = [window.sections[name], _this];
      }
    } else {
      window.sections[name] = _this;
    }
    _this.sectionElement = document.querySelector('#shopify-section-' + id);
    _this.initElements();
    return _this;
  }
  _inherits(sectionClass, _HTMLElement);
  return _createClass(sectionClass, [{
    key: "onRefreshFinish",
    value: function onRefreshFinish(sectionHtmlString) {}
  }]);
}(_wrapNativeSuper(HTMLElement));

;// ./js/helpers/hmacUtils.js
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { hmacUtils_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function hmacUtils_defineProperty(e, r, t) { return (r = hmacUtils_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function hmacUtils_typeof(o) { "@babel/helpers - typeof"; return hmacUtils_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, hmacUtils_typeof(o); }
function hmacUtils_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function hmacUtils_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, hmacUtils_toPropertyKey(o.key), o); } }
function hmacUtils_createClass(e, r, t) { return r && hmacUtils_defineProperties(e.prototype, r), t && hmacUtils_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function hmacUtils_toPropertyKey(t) { var i = hmacUtils_toPrimitive(t, "string"); return "symbol" == hmacUtils_typeof(i) ? i : i + ""; }
function hmacUtils_toPrimitive(t, r) { if ("object" != hmacUtils_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != hmacUtils_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var HmacUtils = function () {
  function HmacUtils() {
    hmacUtils_classCallCheck(this, HmacUtils);
  }
  return hmacUtils_createClass(HmacUtils, null, [{
    key: "parseHmacData",
    value: function parseHmacData(hmacData) {
      var hmacObj;
      if (typeof hmacData === 'string') {
        try {
          var cleanedHmacString = hmacData.replace(/&quot;/g, '"');
          hmacObj = JSON.parse(cleanedHmacString);
        } catch (e) {
          console.error('Failed to parse HMAC string:', e);
          throw new Error('Invalid HMAC data format');
        }
      } else if (hmacUtils_typeof(hmacData) === 'object' && hmacData !== null) {
        hmacObj = _objectSpread({}, hmacData);
      } else {
        throw new Error('HMAC data must be a string or object');
      }
      var _hmacObj = hmacObj,
        timestamp = _hmacObj.timestamp,
        store = _hmacObj.store,
        hmac = _hmacObj.hmac;
      if (!timestamp || !store || !hmac) {
        console.error('Missing required HMAC fields:', hmacObj);
        throw new Error('HMAC data is missing required fields');
      }
      return {
        timestamp: String(timestamp),
        store: String(store),
        hmac: String(hmac)
      };
    }
  }, {
    key: "formatHmacString",
    value: function formatHmacString(hmacData) {
      var _this$parseHmacData = this.parseHmacData(hmacData),
        timestamp = _this$parseHmacData.timestamp,
        store = _this$parseHmacData.store,
        hmac = _this$parseHmacData.hmac;
      var hmacPayload = {
        timestamp: "\"".concat(timestamp, "\""),
        store: "\"".concat(store, "\""),
        hmac: "\"".concat(hmac, "\"")
      };
      return "{\"timestamp\": ".concat(hmacPayload.timestamp, ",\"store\":").concat(hmacPayload.store, ",\"hmac\":").concat(hmacPayload.hmac, "}");
    }
  }, {
    key: "createRequestBody",
    value: function createRequestBody(params, hmacData) {
      var additionalData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return _objectSpread(_objectSpread({}, params), {}, {
        hmac: this.formatHmacString(hmacData)
      }, additionalData);
    }
  }, {
    key: "initFromElement",
    value: function initFromElement(element) {
      var attributeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'data-hmac';
      try {
        var hmacString = element.getAttribute(attributeName);
        if (!hmacString) {
          throw new Error("HMAC attribute '".concat(attributeName, "' not found"));
        }
        var hmacData = this.parseHmacData(hmacString);
        return {
          hmacData: hmacData,
          hmac: hmacData.hmac
        };
      } catch (error) {
        console.error('Error initializing HMAC from element:', error);
        console.error('HMAC string that failed to parse:', element === null || element === void 0 ? void 0 : element.getAttribute(attributeName));
        var emptyHmac = {
          timestamp: '',
          store: '',
          hmac: ''
        };
        return {
          hmacData: emptyHmac,
          hmac: ''
        };
      }
    }
  }]);
}();
/* harmony default export */ var hmacUtils = (HmacUtils);
;// ./js/helpers/favoritesSync.js
function favoritesSync_typeof(o) { "@babel/helpers - typeof"; return favoritesSync_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, favoritesSync_typeof(o); }
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == favoritesSync_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(favoritesSync_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

function syncFavoritesWithServer(_x, _x2, _x3) {
  return _syncFavoritesWithServer.apply(this, arguments);
}
function _syncFavoritesWithServer() {
  _syncFavoritesWithServer = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(customerId, beUrl, hmacData) {
    var requestBody, response, data, cleanRecipes;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(!customerId || !beUrl)) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", null);
        case 2:
          _context.prev = 2;
          requestBody = hmacUtils.createRequestBody({
            customerId: String(customerId),
            handle: '*'
          }, hmacData);
          _context.next = 6;
          return fetch("".concat(beUrl, "/favourite-recipe"), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestBody)
          });
        case 6:
          response = _context.sent;
          if (!response.ok) {
            _context.next = 17;
            break;
          }
          _context.next = 10;
          return response.json();
        case 10:
          data = _context.sent;
          if (!(data.recipes && Array.isArray(data.recipes))) {
            _context.next = 15;
            break;
          }
          cleanRecipes = data.recipes.filter(function (handle) {
            return handle !== '*';
          });
          localStorage.setItem(window.sga.constants.FAVORITES_KEY, JSON.stringify(cleanRecipes));
          return _context.abrupt("return", cleanRecipes);
        case 15:
          _context.next = 18;
          break;
        case 17:
          console.warn("Server sync failed with status: ".concat(response.status));
        case 18:
          return _context.abrupt("return", null);
        case 21:
          _context.prev = 21;
          _context.t0 = _context["catch"](2);
          console.error('Error syncing favorites:', _context.t0);
          return _context.abrupt("return", null);
        case 25:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 21]]);
  }));
  return _syncFavoritesWithServer.apply(this, arguments);
}
function getFavorites() {
  try {
    var favoritesJson = localStorage.getItem(window.sga.constants.FAVORITES_KEY);
    return favoritesJson ? JSON.parse(favoritesJson) : [];
  } catch (error) {
    console.error('Error reading favorites from localStorage:', error);
    return [];
  }
}
function setFavorites(recipes) {
  try {
    localStorage.setItem(window.sga.constants.FAVORITES_KEY, JSON.stringify(recipes));
    return true;
  } catch (error) {
    console.error('Error writing favorites to localStorage:', error);
    return false;
  }
}
;// ./components/recipes-detail/recipes-detail.js
function recipes_detail_typeof(o) { "@babel/helpers - typeof"; return recipes_detail_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, recipes_detail_typeof(o); }
function recipes_detail_regeneratorRuntime() { "use strict"; recipes_detail_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == recipes_detail_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(recipes_detail_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function recipes_detail_asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function recipes_detail_asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { recipes_detail_asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { recipes_detail_asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function recipes_detail_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function recipes_detail_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, recipes_detail_toPropertyKey(o.key), o); } }
function recipes_detail_createClass(e, r, t) { return r && recipes_detail_defineProperties(e.prototype, r), t && recipes_detail_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function recipes_detail_callSuper(t, o, e) { return o = recipes_detail_getPrototypeOf(o), recipes_detail_possibleConstructorReturn(t, recipes_detail_isNativeReflectConstruct() ? Reflect.construct(o, e || [], recipes_detail_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function recipes_detail_possibleConstructorReturn(t, e) { if (e && ("object" == recipes_detail_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return recipes_detail_assertThisInitialized(t); }
function recipes_detail_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function recipes_detail_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (recipes_detail_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function recipes_detail_getPrototypeOf(t) { return recipes_detail_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, recipes_detail_getPrototypeOf(t); }
function recipes_detail_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && recipes_detail_setPrototypeOf(t, e); }
function recipes_detail_setPrototypeOf(t, e) { return recipes_detail_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, recipes_detail_setPrototypeOf(t, e); }
function recipes_detail_defineProperty(e, r, t) { return (r = recipes_detail_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function recipes_detail_toPropertyKey(t) { var i = recipes_detail_toPrimitive(t, "string"); return "symbol" == recipes_detail_typeof(i) ? i : i + ""; }
function recipes_detail_toPrimitive(t, r) { if ("object" != recipes_detail_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != recipes_detail_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




var RecipesDetail = function (_sectionClass) {
  function RecipesDetail() {
    var _this;
    recipes_detail_classCallCheck(this, RecipesDetail);
    _this = recipes_detail_callSuper(this, RecipesDetail, ['recipes_detail']);
    var sectionId = _this.getAttribute('data-section-id') || 'recipes-detail';
    _this.sectionId = sectionId;
    var _HmacUtils$initFromEl = hmacUtils.initFromElement(_this),
      hmacData = _HmacUtils$initFromEl.hmacData,
      hmac = _HmacUtils$initFromEl.hmac;
    _this.hmacData = hmacData;
    _this.hmac = hmac;
    _this.customerId = _this.getAttribute('data-customerid');
    _this.recipeHandle = _this.getAttribute('data-recipe-handle');
    _this.beUrl = _this.getAttribute('data-be-url');
    _this.addToFavoritesButton = _this.querySelector('[data-add-to-favorites]');
    _this.removeFromFavoritesButton = _this.querySelector('[data-remove-from-favorites]');
    if (_this.addToFavoritesButton) {
      _this.addToFavoritesButton.addEventListener('click', function (e) {
        _this.toggleFavorite(e);
      });
    }
    if (_this.removeFromFavoritesButton) {
      _this.removeFromFavoritesButton.addEventListener('click', function (e) {
        _this.toggleFavorite(e);
      });
    }
    _this.fetchAndSyncFavorites().then(function () {
      _this.setInitialButtonState();
    });
    _this.setupStickyBehavior();
    return _this;
  }
  recipes_detail_inherits(RecipesDetail, _sectionClass);
  return recipes_detail_createClass(RecipesDetail, [{
    key: "fetchAndSyncFavorites",
    value: function () {
      var _fetchAndSyncFavorites = recipes_detail_asyncToGenerator(recipes_detail_regeneratorRuntime().mark(function _callee() {
        return recipes_detail_regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return syncFavoritesWithServer(this.customerId, this.beUrl, this.hmacData);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchAndSyncFavorites() {
        return _fetchAndSyncFavorites.apply(this, arguments);
      }
      return fetchAndSyncFavorites;
    }()
  }, {
    key: "setupStickyBehavior",
    value: function setupStickyBehavior() {
      var _this2 = this;
      if (!this.hasAttribute('data-sticky-enabled')) {
        return;
      }
      this.containerElement = this.closest('[data-recipes-container]');
      if (!this.containerElement) {
        return;
      }
      this.isSticky = false;
      this.stickyOffset = parseInt(this.getAttribute('data-sticky-offset'), 10) || RecipesDetail.DEFAULT_STICKY_OFFSET;
      this.fixedLeftOffset = null;
      this.mediaQuery = window.matchMedia('(min-width: 1024px)');
      this.handleMediaChange = function (e) {
        if (e.matches) {
          _this2.enableStickyBehavior();
        } else {
          _this2.disableStickyBehavior();
        }
      };
      if (this.mediaQuery.addEventListener) {
        this.mediaQuery.addEventListener('change', this.handleMediaChange);
      } else {
        this.mediaQuery.addListener(this.handleMediaChange);
      }
      if (this.mediaQuery.matches) {
        this.enableStickyBehavior();
      } else {
        this.disableStickyBehavior();
      }
    }
  }, {
    key: "enableStickyBehavior",
    value: function enableStickyBehavior() {
      var _this3 = this;
      if (this.isSticky) {
        this.resetSticky();
      }
      this.cleanupStickyBehavior();
      requestAnimationFrame(function () {
        return _this3.initializeObservers();
      });
    }
  }, {
    key: "disableStickyBehavior",
    value: function disableStickyBehavior() {
      this.resetSticky();
      this.cleanupStickyBehavior();
    }
  }, {
    key: "cleanupStickyBehavior",
    value: function cleanupStickyBehavior() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
        this.intersectionObserver = null;
      }
      if (this.handleScroll) {
        window.removeEventListener('scroll', this.handleScroll);
        this.handleScroll = null;
      }
      this.fixedLeftOffset = null;
      this.containerIsVisible = false;
      this.rafPending = false;
    }
  }, {
    key: "initializeObservers",
    value: function initializeObservers() {
      var _this4 = this;
      this.recalculatePosition();
      this.resizeObserver = new ResizeObserver(function () {
        return _this4.handleResize();
      });
      this.resizeObserver.observe(this.containerElement);
      this.intersectionObserver = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        _this4.containerIsVisible = entry.isIntersecting;
      }, {
        rootMargin: '100px 0px'
      });
      this.intersectionObserver.observe(this.containerElement);
      this.handleScroll = function () {
        if (!_this4.containerIsVisible) return;
        if (!_this4.rafPending) {
          _this4.rafPending = true;
          requestAnimationFrame(function () {
            _this4.updateStickyPosition();
            _this4.rafPending = false;
          });
        }
      };
      window.addEventListener('scroll', this.handleScroll, {
        passive: true
      });
      this.updateStickyPosition();
    }
  }, {
    key: "recalculatePosition",
    value: function recalculatePosition() {
      var elementRect = this.getBoundingClientRect();
      this.fixedLeftOffset = elementRect.left;
    }
  }, {
    key: "resetSticky",
    value: function resetSticky() {
      this.style.position = '';
      this.style.top = '';
      this.style.left = '';
      this.style.right = '';
      this.isSticky = false;
    }
  }, {
    key: "activateSticky",
    value: function activateSticky() {
      this.style.position = 'fixed';
      this.style.left = "".concat(this.fixedLeftOffset, "px");
      this.style.right = 'auto';
      this.isSticky = true;
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      var _this5 = this;
      if (this.isSticky) {
        this.resetSticky();
      }
      requestAnimationFrame(function () {
        _this5.recalculatePosition();
        _this5.updateStickyPosition();
      });
    }
  }, {
    key: "updateStickyPosition",
    value: function updateStickyPosition() {
      if (this.fixedLeftOffset === null) return;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var containerTop = this.containerElement.offsetTop;
      var containerBottom = containerTop + this.containerElement.offsetHeight;
      var scrolledPastTop = scrollTop > containerTop - this.stickyOffset;
      var scrolledPastBottom = scrollTop + this.stickyOffset + this.offsetHeight >= containerBottom;
      if (!this.isSticky && scrolledPastTop) {
        this.activateSticky();
      }
      if (this.isSticky) {
        if (!scrolledPastTop) {
          this.resetSticky();
        } else if (scrolledPastBottom) {
          this.style.top = "".concat(containerBottom - this.offsetHeight - scrollTop, "px");
        } else {
          this.style.top = "".concat(this.stickyOffset, "px");
        }
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.cleanupStickyBehavior();
      if (this.mediaQuery && this.handleMediaChange) {
        if (this.mediaQuery.removeEventListener) {
          this.mediaQuery.removeEventListener('change', this.handleMediaChange);
        } else {
          this.mediaQuery.removeListener(this.handleMediaChange);
        }
      }
    }
  }, {
    key: "toggleFavorite",
    value: function () {
      var _toggleFavorite = recipes_detail_asyncToGenerator(recipes_detail_regeneratorRuntime().mark(function _callee2(event) {
        var _this6 = this;
        var clickedButton, isRemoving, newFavoriteState, favorites, originalHTML, requestBody, response;
        return recipes_detail_regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this.hmacData) {
                _context2.next = 2;
                break;
              }
              throw new Error('HMAC data is missing or invalid');
            case 2:
              clickedButton = event.currentTarget;
              isRemoving = clickedButton.hasAttribute('data-remove-from-favorites');
              newFavoriteState = !isRemoving;
              favorites = getFavorites();
              if (newFavoriteState) {
                if (!favorites.includes(this.recipeHandle)) {
                  favorites.push(this.recipeHandle);
                  setFavorites(favorites);
                }
              } else {
                favorites = favorites.filter(function (handle) {
                  return handle !== _this6.recipeHandle;
                });
                setFavorites(favorites);
              }
              this.toggleButtonState(newFavoriteState);
              originalHTML = clickedButton.innerHTML;
              clickedButton.disabled = true;
              requestBody = hmacUtils.createRequestBody({
                customerId: String(this.customerId),
                handle: String(this.recipeHandle)
              }, this.hmacData);
              _context2.prev = 11;
              _context2.next = 14;
              return fetch("".concat(this.beUrl, "/favourite-recipe"), {
                method: isRemoving ? 'DELETE' : 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
              });
            case 14:
              response = _context2.sent;
              if (response.ok) {
                _context2.next = 18;
                break;
              }
              this.toggleButtonState(isRemoving);
              throw new Error("Error ".concat(isRemoving ? 'removing from' : 'adding to', " favorites: ").concat(response.status));
            case 18:
              console.log("Successfully ".concat(isRemoving ? 'removed from' : 'added to', " favorites"));
              _context2.next = 25;
              break;
            case 21:
              _context2.prev = 21;
              _context2.t0 = _context2["catch"](11);
              console.error('Error:', _context2.t0);
              this.toggleButtonState(isRemoving);
            case 25:
              _context2.prev = 25;
              if (clickedButton) {
                clickedButton.disabled = false;
                clickedButton.innerHTML = originalHTML;
              }
              return _context2.finish(25);
            case 28:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[11, 21, 25, 28]]);
      }));
      function toggleFavorite(_x) {
        return _toggleFavorite.apply(this, arguments);
      }
      return toggleFavorite;
    }()
  }, {
    key: "setInitialButtonState",
    value: function setInitialButtonState() {
      var addButton = this.querySelector('[data-add-to-favorites]');
      var removeButton = this.querySelector('[data-remove-from-favorites]');
      if (addButton && removeButton) {
        var favorites = getFavorites();
        var isFavorite = favorites.includes(this.recipeHandle);
        if (favorites.length > 0) {
          this.toggleButtonState(isFavorite);
        } else {
          var _isFavorite = removeButton.classList.contains('hidden') === false;
          this.toggleButtonState(_isFavorite);
        }
      }
    }
  }, {
    key: "toggleButtonState",
    value: function toggleButtonState(isFavorite) {
      var addButton = this.querySelector('[data-add-to-favorites]');
      var removeButton = this.querySelector('[data-remove-from-favorites]');
      if (isFavorite) {
        if (addButton) addButton.classList.add('hidden');
        if (removeButton) removeButton.classList.remove('hidden');
      } else {
        if (addButton) addButton.classList.remove('hidden');
        if (removeButton) removeButton.classList.add('hidden');
      }
    }
  }]);
}(sectionClass);
recipes_detail_defineProperty(RecipesDetail, "DEFAULT_STICKY_OFFSET", 160);
if (typeof window !== 'undefined' && !customElements.get('recipes-detail')) {
  customElements.define('recipes-detail', RecipesDetail);
}
/* harmony default export */ var recipes_detail = ((/* unused pure expression or super */ null && (RecipesDetail)));

/***/ }),

/***/ 82:
/***/ (function() {

window.sga = window.sga || {};
window.sga = {
  breakpoints: {
    sm: 600,
    md: 769,
    lg: 1024,
    xl: 1280,
    xxl: 1536
  },
  constants: {
    FAVORITES_KEY: 'favorite_recipes'
  }
};

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
!function() {
"use strict";

;// ./js/helpers/formatMoney.js
function formatMoney(cents) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (!Number.isFinite(cents)) return fallback;
  var shopify = window.Shopify;
  if (typeof (shopify === null || shopify === void 0 ? void 0 : shopify.formatMoney) !== 'function') return fallback;
  return shopify.formatMoney(Math.round(cents));
}
;// ./js/globals.js

window.globals = {
  updateQuickFacts: function updateQuickFacts(quantity, rowData) {
    var quickFactsElements = document.querySelectorAll('[data-quick-facts-item]');
    if (!(quickFactsElements !== null && quickFactsElements !== void 0 && quickFactsElements.length)) return;
    var fromAttribute = 'quickFactsItemValueFrom';
    var toAttribute = 'quickFactsItemValueTo';
    var getElementValue = function getElementValue(element, attribute) {
      var _element$dataset$attr, _element$dataset;
      return Number((_element$dataset$attr = element === null || element === void 0 || (_element$dataset = element.dataset) === null || _element$dataset === void 0 ? void 0 : _element$dataset[attribute]) !== null && _element$dataset$attr !== void 0 ? _element$dataset$attr : 0) * Number(quantity);
    };
    var updateElement = function updateElement(element, value) {
      var _element$innerHTML$le;
      if (((_element$innerHTML$le = element === null || element === void 0 ? void 0 : element.innerHTML.length) !== null && _element$innerHTML$le !== void 0 ? _element$innerHTML$le : 0) > 0) {
        element.innerHTML = value;
      }
    };
    quickFactsElements.forEach(function (quickFact) {
      var itemType = quickFact.dataset.quickFactsItem;
      var fromValueElement = quickFact.querySelector('[data-quick-facts-item-value-from]');
      var toValueElement = quickFact.querySelector('[data-quick-facts-item-value-to]');
      var fromElement = quickFact.querySelector('[data-quick-facts-item-element-from]');
      var toElement = quickFact.querySelector('[data-quick-facts-item-element-to]');
      if (itemType === 'packaging') {
        updateElement(fromElement, getElementValue(fromValueElement, fromAttribute));
        updateElement(toElement, getElementValue(toValueElement, toAttribute));
      }
      if (itemType === 'duration') {
        var durationFrom = getElementValue(fromValueElement, fromAttribute);
        var durationTo = getElementValue(toValueElement, toAttribute);
        updateElement(fromElement, Math.floor(durationFrom));
        updateElement(toElement, Math.floor(durationTo));
      }
      if (itemType === 'price_per_dose' && rowData) {
        var durationSelector = '[data-quick-facts-item="duration"]';
        var durationElement = document.querySelector(durationSelector);
        var durationFromElement = durationElement.querySelector('[data-quick-facts-item-value-from]');
        var durationToElement = durationElement.querySelector('[data-quick-facts-item-value-to]');
        var _durationFrom = getElementValue(durationFromElement, fromAttribute);
        var _durationTo = getElementValue(durationToElement, toAttribute);
        var totalPrice = Number(rowData.price_per_unit_raw) * Number(quantity);
        updateElement(fromElement, formatMoney(totalPrice / _durationFrom));
        updateElement(toElement, formatMoney(totalPrice / _durationTo));
      }
    });
  }
};
// EXTERNAL MODULE: ./js/helpers/_variables.js
var _variables = __webpack_require__(82);
;// ./js/helpers/_scrollToElement.js
var scrollToElement = function scrollToElement(element) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!element) return;
  var offset = -200;
  var delay = 50;
  setTimeout(function () {
    var elementPosition = element.getBoundingClientRect().top + window.scrollY + offset;
    window.scrollTo({
      behavior: 'smooth',
      top: elementPosition
    });
  }, delay);
};
;// ./js/partials/main-product.js

var handleClick = function handleClick(event) {
  var toggleShowMore = event.currentTarget;
  var containerElement = toggleShowMore.closest('[data-toggle-container]');
  var contentWrapperElement = containerElement === null || containerElement === void 0 ? void 0 : containerElement.querySelector('[data-toggle-content-wrapper]');
  var contentElement = containerElement === null || containerElement === void 0 ? void 0 : containerElement.querySelector('[data-toggle-content]');
  var textInnerElement = toggleShowMore.querySelector('[data-toggle-read-more-text]');
  if (!textInnerElement || !containerElement || !contentWrapperElement || !contentElement) return;
  var contentWrapperHeight = "".concat(Number(containerElement.dataset.contentWrapperHeight), "px");
  var textHeight = "".concat(contentElement.scrollHeight, "px");
  var textOldValue = textInnerElement.innerText;
  var textNewValue = textInnerElement.dataset.toggleReadMoreText;
  contentWrapperElement.style.maxHeight = containerElement.classList.contains('open') ? contentWrapperHeight : textHeight;
  containerElement.classList.toggle('open');
  textInnerElement.innerHTML = textNewValue;
  textInnerElement.dataset.toggleReadMoreText = textOldValue;
  if (!containerElement.classList.contains('open')) {
    scrollToElement(containerElement);
  }
};
window.toggleContent = function () {
  var containerElements = document.querySelectorAll('[data-toggle-container]');
  containerElements.forEach(function (containerElement) {
    var toggleShowMore = containerElement.querySelector('[data-toggle-read-more]');
    var contentElement = containerElement.querySelector('[data-toggle-content]');
    var contentWrapperElement = containerElement.querySelector('[data-toggle-content-wrapper]');
    if (!toggleShowMore || !contentElement || !contentWrapperElement) {
      return;
    }
    var contentWrapperHeight = Number(containerElement.dataset.contentWrapperHeight);
    var textHeight = contentElement.scrollHeight;
    containerElement.dataset.textHeight = textHeight;
    var isOpen = containerElement.classList.contains('open');
    contentWrapperElement.style.maxHeight = isOpen ? "".concat(textHeight, "px") : "".concat(contentWrapperHeight, "px");
    if (textHeight > contentWrapperHeight) {
      toggleShowMore.style.display = 'inline-flex';
      if (!toggleShowMore.classList.contains('init')) {
        toggleShowMore.classList.add('init');
        toggleShowMore.addEventListener('click', handleClick);
      }
    } else {
      toggleShowMore.style.display = 'none';
      containerElement.classList.remove('open');
      contentWrapperElement.style.maxHeight = "".concat(contentWrapperHeight, "px");
    }
  });
};
document.addEventListener('DOMContentLoaded', function () {
  window.toggleContent();
});
var toggleContentResizeTimeout = null;
window.addEventListener('resize', function () {
  if (toggleContentResizeTimeout) {
    window.clearTimeout(toggleContentResizeTimeout);
  }
  toggleContentResizeTimeout = window.setTimeout(function () {
    window.toggleContent();
    toggleContentResizeTimeout = null;
  }, 150);
});
// EXTERNAL MODULE: ./components/recipes-detail/recipes-detail.js + 3 modules
var recipes_detail = __webpack_require__(243);
;// ./js/helpers/_selectors.js
var SUBSCRIPTION_WIDGET_SELECTOR = '[data-subscription-widget]';
var PURCHASE_SELECTOR = '[data-purchase-selector]';
var ONE_TIME_BUTTON_SELECTOR = '[data-one-time]';
var SUBSCRIPTION_BUTTON_SELECTOR = '[data-subscription]';
var SUBSCRIPTION_LABEL_VALUE = '[data-subscription-label-value]';
var SUBSCRIPTION_WIDGET_WRAPPER_SELECTOR = '[data-subscription-widget-wrapper]';
var FREQUENCY_DROPDOWN_SELECTOR = '[data-frequency-dropdown]';
var FREQUENCY_SELECTED_SELECTOR = '[data-frequency-selected]';
var FREQUENCY_SELECTED_VALUE_SELECTOR = '[data-frequency-selected-value]';
var FREQUENCY_SELECTED_LABEL_SELECTOR = '[data-frequency-selected-label]';
var FREQUENCY_SELECTED_LABEL_ALT_SELECTOR = '[data-frequency-selected-label-alt]';
var FREQUENCY_OPTIONS_SELECTOR = '[data-frequency-options]';
var FREQUENCY_OPTION_SELECTOR = '[data-frequency-option]';
var QUANTITY_BREAKS_CONTAINER_SELECTOR = '[data-quantity-breaks-container]';
var QUANTITY_DROPDOWN_SELECTOR = '[data-quantity-dropdown]';
var QUANTITY_SELECTED_SELECTOR = '[data-quantity-selected]';
var QUANTITY_SELECTED_TEXT_WRAPPER_SELECTOR = '[data-quantity-selected-text-wrapper]';
var QUANTITY_SELECTED_PRICE_WRAPPER_SELECTOR = '[data-quantity-selected-price-wrapper]';
var QUANTITY_OPTIONS_SELECTOR = '[data-quantity-options]';
var QUANTITY_OPTION_SELECTOR = '[data-quantity-option]';
var QUANTITY_MAIN_TEXT_SELECTOR = '[data-quantity-main-text]';
var QUANTITY_SUB_TEXT_SELECTOR = '[data-quantity-sub-text]';
var QUANTITY_PRICE_SELECTOR = '[data-quantity-price]';
var QUANTITY_DISCOUNT_BADGE_SELECTOR = '[data-quantity-discount-badge]';
var QUANTITY_SAVINGS_SELECTOR = '[data-quantity-savings]';
var QUANTITY_SAVINGS_VALUE_SELECTOR = '[data-quantity-savings-value]';
var QUANTITY_PRICE_WRAPPER_SELECTOR = '[data-quantity-price-wrapper]';
var PRODUCT_PRICE_CONTAINER_SELECTOR = '[data-product-detail-price]';
var PRODUCT_AVAILABILITY_CONTAINER_SELECTOR = '[data-product-detail-availability]';
var PRODUCT_DETAIL_ACTION_TOP_SELECTOR = '[data-product-detail-action-top]';
var PRODUCT_DETAIL_ACTION_BOTTOM_SELECTOR = '[data-product-detail-action-bottom]';
var PRODUCT_DETAIL_ONE_TIME_AVAILABILITY_SELECTOR = '[data-product-detail-one-time-availability]';
var PRODUCT_DELIVERY_INFO_CONTAINER_SELECTOR = '[data-product-detail-delivery-info]';
var PRICE_VALUE_SELECTOR = '[data-cart-price-value]';
var QUANTITY_INPUT_SELECTOR = '[data-cart-quantity-input]';
var PRICE_WAS_SELECTOR = '[data-cart-price-was-value]';
var DISCOUNT_PERCENT_SELECTOR = '[data-cart-discount-percent-value]';
var SAVINGS_AMOUNT_SELECTOR = '[data-cart-discount-value]';
var DISCOUNT_CONTAINER_SELECTOR = '[data-cart-discount-element]';
var SELLING_PLAN_INPUT_SELECTOR = '[data-selling-plan-input-id]';
var PRODUCT_ADD_TO_CART_SELECTOR = '[data-product-add-to-cart]';
var QUANTITY_BASE_INPUT_SELECTOR = '[data-quantity-input]';
var ACTIVE_CLASS = 'active';
var HIDDEN_CLASS = 'hidden';
var FREQUENCY_OPTION_ACTIVE_CLASS = 'sga-subscription-widget__frequency-dropdown__option--active';
var FREQUENCY_OPTIONS_ACTIVE_CLASS = 'sga-subscription-widget__frequency-dropdown__options--active';
var QUANTITY_OPTION_ACTIVE_CLASS = 'sga-subscription-widget__quantity-dropdown__option--active';
var QUANTITY_OPTIONS_ACTIVE_CLASS = 'sga-subscription-widget__quantity-dropdown__options--active';
;// ./js/helpers/_intelligems.js
function getIntelligemsPrice(variantId) {
  if (window.igData && window.igData.price && variantId) {
    var itemPrice = window.igData.price.getPriceByVariantId(parseInt(variantId, 10));
    if (itemPrice) {
      return itemPrice * 100;
    }
  }
  return null;
}
function waitForIntelligems(callback) {
  if (window.igData && window.igData.price) {
    callback();
    return;
  }
  if (window.onIgReady) {
    if (Array.isArray(window.onIgReady)) {
      window.onIgReady.push(callback);
    } else {
      window.onIgReady = [window.onIgReady, callback];
    }
  } else {
    window.onIgReady = callback;
  }
}
;// ./js/partials/_subscription-widget.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var SGASubscriptionWidget = function () {
  function SGASubscriptionWidget(element) {
    var _this$frequencyDropdo, _this$frequencyDropdo2, _this$frequencyDropdo3, _this$frequencyDropdo4, _this$frequencyDropdo5, _this$frequencyOption, _this$quantityDropdow, _this$quantitySelecte, _this$quantitySelecte2, _this$quantityDropdow2, _this$quantityOptions, _this$quantityDropdow3, _this$mainProductPric, _this$mainProductPric2, _this$mainProductPric3, _this$mainProductPric4, _this$mainProductPric5;
    _classCallCheck(this, SGASubscriptionWidget);
    this.widgetElement = element;
    this.savingsText = this.widgetElement.dataset.savingsText;
    this.productId = this.widgetElement.dataset.productId;
    this.oneTimeButton = this.widgetElement.querySelector(ONE_TIME_BUTTON_SELECTOR);
    this.subscriptionButton = this.widgetElement.querySelector(SUBSCRIPTION_BUTTON_SELECTOR);
    this.quantityBreaksContainer = this.widgetElement.querySelector(QUANTITY_BREAKS_CONTAINER_SELECTOR);
    this.subscriptionWidgetWrapper = this.widgetElement.querySelector(SUBSCRIPTION_WIDGET_WRAPPER_SELECTOR);
    this.subscriptionLabelValue = this.widgetElement.querySelector(SUBSCRIPTION_LABEL_VALUE);
    this.frequencyDropdownContainer = this.widgetElement.querySelector(FREQUENCY_DROPDOWN_SELECTOR);
    this.frequencySelectedDisplay = (_this$frequencyDropdo = this.frequencyDropdownContainer) === null || _this$frequencyDropdo === void 0 ? void 0 : _this$frequencyDropdo.querySelector(FREQUENCY_SELECTED_SELECTOR);
    this.frequencySelectedValue = (_this$frequencyDropdo2 = this.frequencyDropdownContainer) === null || _this$frequencyDropdo2 === void 0 ? void 0 : _this$frequencyDropdo2.querySelector(FREQUENCY_SELECTED_VALUE_SELECTOR);
    this.frequencySelectedLabel = (_this$frequencyDropdo3 = this.frequencyDropdownContainer) === null || _this$frequencyDropdo3 === void 0 ? void 0 : _this$frequencyDropdo3.querySelector(FREQUENCY_SELECTED_LABEL_SELECTOR);
    this.frequencySelectedLabelAlt = (_this$frequencyDropdo4 = this.frequencyDropdownContainer) === null || _this$frequencyDropdo4 === void 0 ? void 0 : _this$frequencyDropdo4.querySelector(FREQUENCY_SELECTED_LABEL_ALT_SELECTOR);
    this.frequencyOptionsContainer = (_this$frequencyDropdo5 = this.frequencyDropdownContainer) === null || _this$frequencyDropdo5 === void 0 ? void 0 : _this$frequencyDropdo5.querySelector(FREQUENCY_OPTIONS_SELECTOR);
    this.frequencyOptions = ((_this$frequencyOption = this.frequencyOptionsContainer) === null || _this$frequencyOption === void 0 ? void 0 : _this$frequencyOption.querySelectorAll(FREQUENCY_OPTION_SELECTOR)) || [];
    this.quantityDropdown = this.widgetElement.querySelector(QUANTITY_DROPDOWN_SELECTOR);
    this.quantitySelectedDisplay = (_this$quantityDropdow = this.quantityDropdown) === null || _this$quantityDropdow === void 0 ? void 0 : _this$quantityDropdow.querySelector(QUANTITY_SELECTED_SELECTOR);
    this.quantitySelectedTextWrapper = (_this$quantitySelecte = this.quantitySelectedDisplay) === null || _this$quantitySelecte === void 0 ? void 0 : _this$quantitySelecte.querySelector(QUANTITY_SELECTED_TEXT_WRAPPER_SELECTOR);
    this.quantitySelectedPriceWrapper = (_this$quantitySelecte2 = this.quantitySelectedDisplay) === null || _this$quantitySelecte2 === void 0 ? void 0 : _this$quantitySelecte2.querySelector(QUANTITY_SELECTED_PRICE_WRAPPER_SELECTOR);
    this.quantityOptionsContainer = (_this$quantityDropdow2 = this.quantityDropdown) === null || _this$quantityDropdow2 === void 0 ? void 0 : _this$quantityDropdow2.querySelector(QUANTITY_OPTIONS_SELECTOR);
    this.quantityOptions = ((_this$quantityOptions = this.quantityOptionsContainer) === null || _this$quantityOptions === void 0 ? void 0 : _this$quantityOptions.querySelectorAll(QUANTITY_OPTION_SELECTOR)) || [];
    this.productPrice = parseFloat((_this$quantityDropdow3 = this.quantityDropdown) === null || _this$quantityDropdow3 === void 0 ? void 0 : _this$quantityDropdow3.dataset.productPrice) || 0;
    this.mainProductPriceContainer = document.querySelector(PRODUCT_PRICE_CONTAINER_SELECTOR);
    this.mainProductAvailabilityContainer = document.querySelector(PRODUCT_AVAILABILITY_CONTAINER_SELECTOR);
    this.mainProductDetailActionBottomContainer = document.querySelector(PRODUCT_DETAIL_ACTION_BOTTOM_SELECTOR);
    this.mainProductOneTimeAvailabilityContainer = document.querySelector(PRODUCT_DETAIL_ONE_TIME_AVAILABILITY_SELECTOR);
    this.mainProductDetailActionTopContainer = document.querySelector(PRODUCT_DETAIL_ACTION_TOP_SELECTOR);
    this.mainProductDeliveryInfoContainer = document.querySelector(PRODUCT_DELIVERY_INFO_CONTAINER_SELECTOR);
    this.mainPriceValueElement = (_this$mainProductPric = this.mainProductPriceContainer) === null || _this$mainProductPric === void 0 ? void 0 : _this$mainProductPric.querySelector(PRICE_VALUE_SELECTOR);
    this.mainQuantityInputElement = document.querySelector(QUANTITY_INPUT_SELECTOR);
    this.mainPriceWasElement = (_this$mainProductPric2 = this.mainProductPriceContainer) === null || _this$mainProductPric2 === void 0 ? void 0 : _this$mainProductPric2.querySelector(PRICE_WAS_SELECTOR);
    this.mainDiscountPercentElement = (_this$mainProductPric3 = this.mainProductPriceContainer) === null || _this$mainProductPric3 === void 0 ? void 0 : _this$mainProductPric3.querySelector(DISCOUNT_PERCENT_SELECTOR);
    this.mainSavingsAmountElement = (_this$mainProductPric4 = this.mainProductPriceContainer) === null || _this$mainProductPric4 === void 0 ? void 0 : _this$mainProductPric4.querySelector(SAVINGS_AMOUNT_SELECTOR);
    this.mainDiscountContainerElement = (_this$mainProductPric5 = this.mainProductPriceContainer) === null || _this$mainProductPric5 === void 0 ? void 0 : _this$mainProductPric5.querySelector(DISCOUNT_CONTAINER_SELECTOR);
    this.sellingPlanInput = document.querySelector(SELLING_PLAN_INPUT_SELECTOR);
    this.mainProductQuantitySelector = document.querySelector("".concat(PRODUCT_ADD_TO_CART_SELECTOR, " ").concat(QUANTITY_BASE_INPUT_SELECTOR));
    this.init();
  }
  return _createClass(SGASubscriptionWidget, [{
    key: "init",
    value: function init() {
      var _this = this;
      waitForIntelligems(function () {
        var intelliGemsPrice = getIntelligemsPrice(_this.productId);
        if (intelliGemsPrice) {
          _this.productPrice = intelliGemsPrice;
          _this.updateQuantityOptionsWithIntelligemsPrice();
        }
      });
      if (this.oneTimeButton && this.subscriptionButton) {
        this.oneTimeButton.addEventListener('click', function () {
          return _this.selectPurchaseType('one-time');
        });
        this.subscriptionButton.addEventListener('click', function () {
          return _this.selectPurchaseType('subscription');
        });
        if (!this.oneTimeButton.classList.contains(ACTIVE_CLASS) && !this.subscriptionButton.classList.contains(ACTIVE_CLASS)) {
          this.oneTimeButton.classList.add(ACTIVE_CLASS);
        }
        this._hideMainProductQuantitySelector(this.subscriptionButton.classList.contains(ACTIVE_CLASS) && this.mainProductQuantitySelector);
        this.updateVisibility();
      }
      var initialFrequencyDiscount = 0;
      var initialSellingPlanId = '';
      if (this.frequencyDropdownContainer && this.frequencySelectedDisplay && this.frequencyOptions && this.frequencyOptions.length > 0) {
        this.frequencySelectedDisplay.addEventListener('click', function (event) {
          return _this.toggleDropdown(event, _this.frequencyOptionsContainer);
        });
        this.frequencyOptions.forEach(function (option) {
          option.addEventListener('click', function (event) {
            return _this.selectFrequencyOption(event);
          });
        });
        var activeFrequencyOption = this.frequencyOptionsContainer.querySelector(".".concat(FREQUENCY_OPTION_ACTIVE_CLASS));
        if (activeFrequencyOption) {
          if (this.frequencySelectedValue) {
            this.frequencySelectedValue.textContent = activeFrequencyOption.dataset.sellingPlanName;
            if (this.frequencySelectedLabelAlt) {
              this.frequencySelectedLabelAlt.textContent = activeFrequencyOption.dataset.sellingPlanLabelAlt;
            }
            if (this.frequencySelectedLabel) {
              this.frequencySelectedLabel.textContent = activeFrequencyOption.dataset.sellingPlanLabel;
            }
          }
          this._setRadioChecked(activeFrequencyOption);
          initialFrequencyDiscount = parseFloat(activeFrequencyOption.dataset.discountPercentage) || 0;
          initialSellingPlanId = activeFrequencyOption.dataset.sellingPlanId || '';
        } else {
          if (this.sellingPlanInput && this.subscriptionButton && this.subscriptionButton.classList.contains(ACTIVE_CLASS)) {
            this.sellingPlanInput.value = '';
          }
        }
      } else {
        if (this.sellingPlanInput && this.subscriptionButton && this.subscriptionButton.classList.contains(ACTIVE_CLASS)) {
          this.sellingPlanInput.value = '';
        }
      }
      var initialQuantity = 1;
      if (this.quantityDropdown && this.quantitySelectedDisplay && this.quantityOptions && this.quantityOptions.length > 0) {
        var _this$quantityOptions2;
        this.quantitySelectedDisplay.addEventListener('click', function (event) {
          return _this.toggleDropdown(event, _this.quantityOptionsContainer);
        });
        this.quantityOptions.forEach(function (option) {
          option.addEventListener('click', function (event) {
            return _this.selectQuantityOption(event);
          });
        });
        var activeQuantityOption = (_this$quantityOptions2 = this.quantityOptionsContainer) === null || _this$quantityOptions2 === void 0 ? void 0 : _this$quantityOptions2.querySelector(".".concat(QUANTITY_OPTION_ACTIVE_CLASS));
        if (activeQuantityOption) {
          initialQuantity = parseInt(activeQuantityOption.dataset.quantity) || 1;
          this._setRadioChecked(activeQuantityOption);
        }
      }
      document.addEventListener('click', function (event) {
        return _this.handleClickOutside(event);
      });
      this._updateMainProductQuantityInput(initialQuantity);
      if (this.sellingPlanInput && this.subscriptionButton && this.subscriptionButton.classList.contains(ACTIVE_CLASS)) {
        this.sellingPlanInput.value = initialSellingPlanId;
      }
      this._updateMainProductPriceDisplay();
    }
  }, {
    key: "_setRadioChecked",
    value: function _setRadioChecked(parentElement) {
      var checked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var radio = parentElement === null || parentElement === void 0 ? void 0 : parentElement.querySelector('input[type="radio"]');
      if (radio) radio.checked = checked;
    }
  }, {
    key: "_hideMainProductQuantitySelector",
    value: function _hideMainProductQuantitySelector(hide) {
      var _this$mainProductQuan;
      var quantityInput = (_this$mainProductQuan = this.mainProductQuantitySelector) === null || _this$mainProductQuan === void 0 ? void 0 : _this$mainProductQuan.closest('quantity-input');
      if (!quantityInput) return;
      quantityInput.style.display = hide ? 'none' : '';
    }
  }, {
    key: "_updateMainProductPriceDisplay",
    value: function _updateMainProductPriceDisplay() {
      if (typeof Shopify.formatMoney !== 'function') return;
      var isSubscriptionActive = this.subscriptionButton && this.subscriptionButton.classList.contains(ACTIVE_CLASS);
      if (isSubscriptionActive) {
        var activeQuantityOption = this.quantityOptionsContainer ? this.quantityOptionsContainer.querySelector(".".concat(QUANTITY_OPTION_ACTIVE_CLASS)) : null;
        var newQuantity = parseInt(activeQuantityOption.dataset.quantity) || 1;
        var optionDiscountPercentageText = activeQuantityOption.querySelector(QUANTITY_DISCOUNT_BADGE_SELECTOR).textContent;
        var optionDiscountPercentageValue = parseFloat(optionDiscountPercentageText.replace('%', '')) || 0;
        var priceText = activeQuantityOption.querySelector(QUANTITY_PRICE_SELECTOR).textContent;
        var savingsText = activeQuantityOption.querySelector(QUANTITY_SAVINGS_VALUE_SELECTOR).textContent;
        var currentPrice = getIntelligemsPrice(this.productId) || this.productPrice;
        var totalOldPrice = currentPrice * newQuantity;
        if (this.mainPriceValueElement) {
          this.mainPriceValueElement.innerHTML = priceText;
        }
        if (this.mainPriceWasElement) {
          this.mainPriceWasElement.innerHTML = Shopify.formatMoney(totalOldPrice);
        }
        if (this.mainDiscountPercentElement) {
          this.mainDiscountPercentElement.textContent = optionDiscountPercentageValue;
        }
        if (this.mainSavingsAmountElement) {
          this.mainSavingsAmountElement.innerHTML = savingsText;
        }
        if (this.mainDiscountContainerElement) {
          this.mainDiscountContainerElement.classList.remove('!hidden');
        }
        var pricePerUnitRaw = currentPrice - currentPrice * optionDiscountPercentageValue / 100;
        window.globals.updateQuickFacts(newQuantity, {
          price_per_unit_raw: pricePerUnitRaw
        });
      }
    }
  }, {
    key: "_updateMainProductQuantityInput",
    value: function _updateMainProductQuantityInput(quantity) {
      if (this.mainQuantityInputElement) {
        this.mainQuantityInputElement.value = quantity;
      }
    }
  }, {
    key: "_updateDiscountBadge",
    value: function _updateDiscountBadge(priceWrapperElement, totalDiscountPercentage) {
      if (!priceWrapperElement) return;
      var badgeEl = priceWrapperElement.querySelector(QUANTITY_DISCOUNT_BADGE_SELECTOR);
      if (badgeEl) {
        if (totalDiscountPercentage > 0) {
          badgeEl.textContent = "-".concat(Math.round(totalDiscountPercentage), "%");
          badgeEl.style.display = 'inline-block';
        } else {
          badgeEl.textContent = '';
          badgeEl.style.display = 'none';
        }
      }
    }
  }, {
    key: "selectPurchaseType",
    value: function selectPurchaseType(type) {
      var _this2 = this;
      if (!this.oneTimeButton || !this.subscriptionButton) return;
      var frequencyDiscountForQuantityUpdate = 0;
      var activeSellingPlanId = '';
      if (type === 'one-time') {
        var _this$mainProductAvai, _this$mainProductPric6, _this$mainProductDeta, _this$mainProductOneT, _this$mainProductDeta2, _this$mainProductDeli, _this$oneTimeButton, _this$subscriptionBut, _this$quantityBreaksC;
        (_this$mainProductAvai = this.mainProductAvailabilityContainer) === null || _this$mainProductAvai === void 0 || _this$mainProductAvai.classList.add("!".concat(HIDDEN_CLASS));
        (_this$mainProductPric6 = this.mainProductPriceContainer) === null || _this$mainProductPric6 === void 0 || _this$mainProductPric6.classList.remove("!".concat(HIDDEN_CLASS));
        (_this$mainProductDeta = this.mainProductDetailActionBottomContainer) === null || _this$mainProductDeta === void 0 || _this$mainProductDeta.classList.remove("!".concat(HIDDEN_CLASS));
        (_this$mainProductOneT = this.mainProductOneTimeAvailabilityContainer) === null || _this$mainProductOneT === void 0 || _this$mainProductOneT.classList.remove("!".concat(HIDDEN_CLASS));
        (_this$mainProductDeta2 = this.mainProductDetailActionTopContainer) === null || _this$mainProductDeta2 === void 0 || _this$mainProductDeta2.classList.remove("isSubscription");
        (_this$mainProductDeli = this.mainProductDeliveryInfoContainer) === null || _this$mainProductDeli === void 0 || _this$mainProductDeli.classList.remove("!".concat(HIDDEN_CLASS));
        (_this$oneTimeButton = this.oneTimeButton) === null || _this$oneTimeButton === void 0 || _this$oneTimeButton.classList.add(ACTIVE_CLASS);
        (_this$subscriptionBut = this.subscriptionButton) === null || _this$subscriptionBut === void 0 || _this$subscriptionBut.classList.remove(ACTIVE_CLASS);
        this._hideMainProductQuantitySelector(!this.mainProductQuantitySelector);
        if (this.sellingPlanInput) {
          this.sellingPlanInput.value = '';
        }
        var selectedOneTimeRadio = (_this$quantityBreaksC = this.quantityBreaksContainer) === null || _this$quantityBreaksC === void 0 ? void 0 : _this$quantityBreaksC.querySelector('.quantity-breaks__row.selected input');
        if (selectedOneTimeRadio) {
          var selectedQuantity = selectedOneTimeRadio.dataset.lastInputValue || 1;
          if (selectedQuantity) {
            var quantityBreakRow = document.querySelector(".sga-subscription-widget__quantity-breaks-container [data-quantity-breaks-row][data-row-quantity=\"".concat(selectedQuantity, "\"]"));
            if (quantityBreakRow) {
              var radioToSelect = quantityBreakRow.querySelector('input[type="radio"]');
              if (radioToSelect && !radioToSelect.checked) {
                radioToSelect.checked = true;
                radioToSelect.dispatchEvent(new Event('change', {
                  bubbles: true
                }));
              } else if (radioToSelect && radioToSelect.checked) {
                radioToSelect.dispatchEvent(new Event('change', {
                  bubbles: true
                }));
              }
            } else {
              selectedOneTimeRadio.dispatchEvent(new CustomEvent('change', {
                bubbles: true,
                detail: {
                  quantityValue: selectedQuantity
                }
              }));
            }
          }
        } else {
          var _defaultProductPriceD;
          var defaultProductPriceJson = document.querySelector('[data-product-detail-price] [data-price-json]');
          var productQuantityInput = document.querySelector('[data-cart-quantity-input]');
          var quantity = productQuantityInput.dataset.lastInputValue || 1;
          if (!defaultProductPriceJson) return;
          var defaultProductPriceData = JSON.parse(defaultProductPriceJson.textContent);
          var currentPrice = getIntelligemsPrice(this.productId) || defaultProductPriceData.price_raw;
          var formattedPrice = Shopify.formatMoney(currentPrice * quantity);
          document.querySelector('[data-cart-quantity-input]').value = quantity;
          document.querySelector('[data-product-detail-price] [data-cart-price-value]').innerHTML = formattedPrice;
          document.querySelector('[data-product-detail-price] [data-cart-price-was-value]').innerHTML = (_defaultProductPriceD = defaultProductPriceData.compare_at_price) !== null && _defaultProductPriceD !== void 0 ? _defaultProductPriceD : null;
          document.querySelector('[data-product-detail-price] [data-cart-discount-percent-value]').innerHTML = defaultProductPriceData.discount_percent;
          document.querySelector('[data-product-detail-price] [data-cart-discount-value]').innerHTML = defaultProductPriceData.discount_amount;
          document.querySelector('[data-product-detail-price] [data-cart-discount-element]').classList.toggle('!hidden', !defaultProductPriceData.discount_amount);
          window.globals.updateQuickFacts(quantity, {
            price_per_unit_raw: currentPrice
          });
        }
      } else if (type === 'subscription') {
        var _this$mainProductAvai2, _this$mainProductPric7, _this$mainProductDeta3, _this$mainProductOneT2, _this$mainProductDeta4, _this$mainProductDeli2, _this$subscriptionBut2, _this$oneTimeButton2, _this$quantityOptions3;
        (_this$mainProductAvai2 = this.mainProductAvailabilityContainer) === null || _this$mainProductAvai2 === void 0 || _this$mainProductAvai2.classList.remove("!".concat(HIDDEN_CLASS));
        (_this$mainProductPric7 = this.mainProductPriceContainer) === null || _this$mainProductPric7 === void 0 || _this$mainProductPric7.classList.add("!".concat(HIDDEN_CLASS));
        (_this$mainProductDeta3 = this.mainProductDetailActionBottomContainer) === null || _this$mainProductDeta3 === void 0 || _this$mainProductDeta3.classList.add("!".concat(HIDDEN_CLASS));
        (_this$mainProductOneT2 = this.mainProductOneTimeAvailabilityContainer) === null || _this$mainProductOneT2 === void 0 || _this$mainProductOneT2.classList.add("!".concat(HIDDEN_CLASS));
        (_this$mainProductDeta4 = this.mainProductDetailActionTopContainer) === null || _this$mainProductDeta4 === void 0 || _this$mainProductDeta4.classList.add("isSubscription");
        (_this$mainProductDeli2 = this.mainProductDeliveryInfoContainer) === null || _this$mainProductDeli2 === void 0 || _this$mainProductDeli2.classList.add("!".concat(HIDDEN_CLASS));
        (_this$subscriptionBut2 = this.subscriptionButton) === null || _this$subscriptionBut2 === void 0 || _this$subscriptionBut2.classList.add(ACTIVE_CLASS);
        (_this$oneTimeButton2 = this.oneTimeButton) === null || _this$oneTimeButton2 === void 0 || _this$oneTimeButton2.classList.remove(ACTIVE_CLASS);
        this._hideMainProductQuantitySelector(this.mainProductQuantitySelector);
        var activeFrequencyOption = this.frequencyOptionsContainer ? this.frequencyOptionsContainer.querySelector(".".concat(FREQUENCY_OPTION_ACTIVE_CLASS)) : null;
        if (activeFrequencyOption) {
          frequencyDiscountForQuantityUpdate = parseFloat(activeFrequencyOption.dataset.discountPercentage) || 0;
          activeSellingPlanId = activeFrequencyOption.dataset.sellingPlanId || '';
        }
        this.sellingPlanInput.value = activeSellingPlanId;
        var activeSubQuantityOption = (_this$quantityOptions3 = this.quantityOptionsContainer) === null || _this$quantityOptions3 === void 0 ? void 0 : _this$quantityOptions3.querySelector(".".concat(QUANTITY_OPTION_ACTIVE_CLASS));
        if (activeSubQuantityOption) {
          var _this$quantityOptions4;
          var selectedQuantityValue = activeSubQuantityOption.dataset.quantity;
          var subQuantityOptionToActivate = (_this$quantityOptions4 = this.quantityOptionsContainer) === null || _this$quantityOptions4 === void 0 ? void 0 : _this$quantityOptions4.querySelector("".concat(QUANTITY_OPTION_SELECTOR, "[data-quantity=\"").concat(selectedQuantityValue, "\"]"));
          if (subQuantityOptionToActivate) {
            this.quantityOptions.forEach(function (opt) {
              opt.classList.remove(QUANTITY_OPTION_ACTIVE_CLASS);
              _this2._setRadioChecked(opt, false);
            });
            subQuantityOptionToActivate.classList.add(QUANTITY_OPTION_ACTIVE_CLASS);
            this._setRadioChecked(subQuantityOptionToActivate);
            this.updateSelectedQuantityDisplay(subQuantityOptionToActivate);
            this._updateMainProductQuantityInput(parseInt(selectedQuantityValue));
          } else {
            var _this$quantityOptions5;
            var firstSubQuantityOption = (_this$quantityOptions5 = this.quantityOptionsContainer) === null || _this$quantityOptions5 === void 0 ? void 0 : _this$quantityOptions5.querySelector("".concat(QUANTITY_OPTION_SELECTOR, "[data-quantity=\"1\"]"));
            this.quantityOptions.forEach(function (opt) {
              opt.classList.remove(QUANTITY_OPTION_ACTIVE_CLASS);
              var optRadio = opt.querySelector('input[type="radio"]');
              if (optRadio) optRadio.checked = false;
            });
            firstSubQuantityOption.classList.add(QUANTITY_OPTION_ACTIVE_CLASS);
            this._setRadioChecked(firstSubQuantityOption);
            this.updateSelectedQuantityDisplay(firstSubQuantityOption);
            this._updateMainProductQuantityInput(1);
          }
        }
      }
      this.updateQuantityOptionsWithDiscount(frequencyDiscountForQuantityUpdate);
      this.updateVisibility();
      this._updateMainProductPriceDisplay();
    }
  }, {
    key: "updateVisibility",
    value: function updateVisibility() {
      var isOneTimeActive = this.oneTimeButton && this.oneTimeButton.classList.contains(ACTIVE_CLASS);
      var isSubscriptionActive = this.subscriptionButton && this.subscriptionButton.classList.contains(ACTIVE_CLASS);
      if (!isSubscriptionActive && this.frequencyOptionsContainer) {
        this.frequencyOptionsContainer.classList.remove(FREQUENCY_OPTIONS_ACTIVE_CLASS);
      }
      if (!isSubscriptionActive && this.quantityOptionsContainer) {
        this.quantityOptionsContainer.classList.remove(QUANTITY_OPTIONS_ACTIVE_CLASS);
      }
      if (this.subscriptionWidgetWrapper) {
        this.subscriptionWidgetWrapper.classList.toggle(HIDDEN_CLASS, !isSubscriptionActive);
      }
      if (this.quantityBreaksContainer) {
        this.quantityBreaksContainer.classList.toggle(HIDDEN_CLASS, !isOneTimeActive);
      }
    }
  }, {
    key: "toggleDropdown",
    value: function toggleDropdown(event, optionsContainer) {
      if (!optionsContainer) return;
      event.stopPropagation();
      optionsContainer.classList.toggle(optionsContainer.classList.contains('sga-subscription-widget__quantity-dropdown__options') ? QUANTITY_OPTIONS_ACTIVE_CLASS : FREQUENCY_OPTIONS_ACTIVE_CLASS);
    }
  }, {
    key: "selectFrequencyOption",
    value: function selectFrequencyOption(event) {
      var _this3 = this;
      var selectedOption = event.currentTarget;
      this._setRadioChecked(selectedOption);
      if (this.frequencySelectedValue) {
        this.frequencySelectedValue.textContent = selectedOption.dataset.sellingPlanName;
        if (this.frequencySelectedLabelAlt) {
          this.frequencySelectedLabelAlt.textContent = selectedOption.dataset.sellingPlanLabelAlt;
        }
        if (this.frequencySelectedLabel) {
          this.frequencySelectedLabel.textContent = selectedOption.dataset.sellingPlanLabel;
        }
      }
      if (this.frequencyOptions) {
        this.frequencyOptions.forEach(function (opt) {
          opt.classList.remove(FREQUENCY_OPTION_ACTIVE_CLASS);
          _this3._setRadioChecked(opt, false);
        });
      }
      selectedOption.classList.add(FREQUENCY_OPTION_ACTIVE_CLASS);
      this._setRadioChecked(selectedOption);
      var sellingPlanId = selectedOption.dataset.sellingPlanId || '';
      if (this.sellingPlanInput) {
        this.sellingPlanInput.value = sellingPlanId;
      }
      if (this.frequencyOptionsContainer) {
        this.frequencyOptionsContainer.classList.remove(FREQUENCY_OPTIONS_ACTIVE_CLASS);
      }
      var newFrequencyDiscount = parseFloat(selectedOption.dataset.discountPercentage) || 0;
      this.updateQuantityOptionsWithDiscount(newFrequencyDiscount);
      this._updateMainProductPriceDisplay();
      this.subscriptionLabelValue.innerHTML = newFrequencyDiscount;
    }
  }, {
    key: "updateQuantityOptionsWithIntelligemsPrice",
    value: function updateQuantityOptionsWithIntelligemsPrice() {
      var frequencyDiscountPercentage = 0;
      var activeFrequencyOption = this.frequencyOptionsContainer ? this.frequencyOptionsContainer.querySelector(".".concat(FREQUENCY_OPTION_ACTIVE_CLASS)) : null;
      if (activeFrequencyOption) {
        frequencyDiscountPercentage = parseFloat(activeFrequencyOption.dataset.discountPercentage) || 0;
      }
      this.updateQuantityOptionsWithDiscount(frequencyDiscountPercentage);
      if (this.subscriptionButton && this.subscriptionButton.classList.contains(ACTIVE_CLASS)) {
        this._updateMainProductPriceDisplay();
      }
    }
  }, {
    key: "updateQuantityOptionsWithDiscount",
    value: function updateQuantityOptionsWithDiscount(frequencyDiscountPercentage) {
      var _this4 = this;
      if (!this.quantityOptions || this.quantityOptions.length === 0 || typeof Shopify.formatMoney !== 'function') return;
      this.quantityOptions.forEach(function (option) {
        var quantity = parseInt(option.dataset.quantity);
        var originalTotalForOption = _this4.productPrice * quantity;
        var priceAfterFrequencyDiscount = originalTotalForOption * (1 - frequencyDiscountPercentage / 100);
        var totalSavingsForOption = originalTotalForOption - priceAfterFrequencyDiscount;
        var priceWrapper = option.querySelector(QUANTITY_PRICE_WRAPPER_SELECTOR);
        var priceDisplay = priceWrapper === null || priceWrapper === void 0 ? void 0 : priceWrapper.querySelector(QUANTITY_PRICE_SELECTOR);
        var savingsDisplay = priceWrapper === null || priceWrapper === void 0 ? void 0 : priceWrapper.querySelector(QUANTITY_SAVINGS_VALUE_SELECTOR);
        var optionDiscountPercentageEl = priceWrapper === null || priceWrapper === void 0 ? void 0 : priceWrapper.querySelector(QUANTITY_DISCOUNT_BADGE_SELECTOR);
        if (optionDiscountPercentageEl) optionDiscountPercentageEl.innerHTML = "".concat(frequencyDiscountPercentage, "%");
        if (priceDisplay) priceDisplay.innerHTML = Shopify.formatMoney(priceAfterFrequencyDiscount);
        if (savingsDisplay) {
          if (totalSavingsForOption > 0) {
            savingsDisplay.innerHTML = Shopify.formatMoney(totalSavingsForOption);
          } else {
            savingsDisplay.innerHTML = Shopify.formatMoney(0);
          }
        }
      });
      var activeQuantityOption = this.quantityOptionsContainer ? this.quantityOptionsContainer.querySelector(".".concat(QUANTITY_OPTION_ACTIVE_CLASS)) : null;
      if (activeQuantityOption) {
        this.updateSelectedQuantityDisplay(activeQuantityOption);
      }
    }
  }, {
    key: "selectQuantityOption",
    value: function selectQuantityOption(event) {
      var _this5 = this;
      var selectedOption = event.currentTarget;
      var radioInput = selectedOption.querySelector('input[type="radio"]');
      var newQuantity = parseInt(selectedOption.dataset.quantity) || 1;
      var frequencyDiscountForQuantityUpdate = 0;
      var activeFrequencyOption = this.frequencyOptionsContainer ? this.frequencyOptionsContainer.querySelector(".".concat(FREQUENCY_OPTION_ACTIVE_CLASS)) : null;
      if (activeFrequencyOption) {
        frequencyDiscountForQuantityUpdate = parseFloat(activeFrequencyOption.dataset.discountPercentage) || 0;
      }
      if (this.quantityOptions) {
        this.quantityOptions.forEach(function (opt) {
          opt.classList.remove(QUANTITY_OPTION_ACTIVE_CLASS);
          _this5._setRadioChecked(opt, false);
        });
      }
      selectedOption.classList.add(QUANTITY_OPTION_ACTIVE_CLASS);
      if (radioInput) radioInput.checked = true;
      this.updateSelectedQuantityDisplay(selectedOption);
      if (this.quantityOptionsContainer) {
        this.quantityOptionsContainer.classList.remove(QUANTITY_OPTIONS_ACTIVE_CLASS);
      }
      this._updateMainProductQuantityInput(newQuantity);
      this._updateMainProductPriceDisplay();
    }
  }, {
    key: "updateSelectedQuantityDisplay",
    value: function updateSelectedQuantityDisplay(selectedQuantityOption) {
      if (!this.quantitySelectedTextWrapper || !this.quantitySelectedPriceWrapper || typeof Shopify.formatMoney !== 'function') return;
      var mainTextEl = this.quantitySelectedTextWrapper.querySelector(QUANTITY_MAIN_TEXT_SELECTOR);
      var subTextEl = this.quantitySelectedTextWrapper.querySelector(QUANTITY_SUB_TEXT_SELECTOR);
      var optionDiscountPercentageEl = this.quantitySelectedPriceWrapper.querySelector(QUANTITY_DISCOUNT_BADGE_SELECTOR);
      var priceEl = this.quantitySelectedPriceWrapper.querySelector(QUANTITY_PRICE_SELECTOR);
      var savingsEl = this.quantitySelectedPriceWrapper.querySelector(QUANTITY_SAVINGS_SELECTOR);
      var optionMainText = selectedQuantityOption.querySelector(QUANTITY_MAIN_TEXT_SELECTOR).textContent;
      var optionSubText = selectedQuantityOption.querySelector(QUANTITY_SUB_TEXT_SELECTOR).textContent;
      var optionDiscountPercentageText = selectedQuantityOption.querySelector(QUANTITY_DISCOUNT_BADGE_SELECTOR).textContent;
      var priceText = selectedQuantityOption.querySelector(QUANTITY_PRICE_SELECTOR).textContent;
      var savingsText = selectedQuantityOption.querySelector(QUANTITY_SAVINGS_SELECTOR).textContent;
      if (mainTextEl) mainTextEl.textContent = optionMainText;
      if (subTextEl) subTextEl.textContent = optionSubText;
      if (optionDiscountPercentageEl) optionDiscountPercentageEl.textContent = optionDiscountPercentageText;
      if (priceEl) priceEl.textContent = priceText;
      if (savingsEl) savingsEl.textContent = savingsText;
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside(event) {
      if (this.frequencyOptionsContainer && this.frequencyOptionsContainer.classList.contains(FREQUENCY_OPTIONS_ACTIVE_CLASS)) {
        if (this.frequencyDropdownContainer && !this.frequencyDropdownContainer.contains(event.target)) {
          this.frequencyOptionsContainer.classList.remove(FREQUENCY_OPTIONS_ACTIVE_CLASS);
        }
      }
      if (this.quantityOptionsContainer && this.quantityOptionsContainer.classList.contains(QUANTITY_OPTIONS_ACTIVE_CLASS)) {
        if (this.quantityDropdown && !this.quantityDropdown.contains(event.target)) {
          this.quantityOptionsContainer.classList.remove(QUANTITY_OPTIONS_ACTIVE_CLASS);
        }
      }
    }
  }]);
}();
function initSubscriptionWidget() {
  var subscriptionWidgets = document.querySelectorAll(SUBSCRIPTION_WIDGET_SELECTOR);
  subscriptionWidgets.forEach(function (widgetElement) {
    new SGASubscriptionWidget(widgetElement);
  });
}
document.addEventListener('DOMContentLoaded', function () {
  return initSubscriptionWidget();
});
document.addEventListener('on:variant:content:updated', function () {
  return initSubscriptionWidget();
});
;// ./js/partials/_quantity-breaks.js
function _quantity_breaks_typeof(o) { "@babel/helpers - typeof"; return _quantity_breaks_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _quantity_breaks_typeof(o); }
function _quantity_breaks_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _quantity_breaks_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _quantity_breaks_toPropertyKey(o.key), o); } }
function _quantity_breaks_createClass(e, r, t) { return r && _quantity_breaks_defineProperties(e.prototype, r), t && _quantity_breaks_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _quantity_breaks_toPropertyKey(t) { var i = _quantity_breaks_toPrimitive(t, "string"); return "symbol" == _quantity_breaks_typeof(i) ? i : i + ""; }
function _quantity_breaks_toPrimitive(t, r) { if ("object" != _quantity_breaks_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _quantity_breaks_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _quantity_breaks_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }

if (!customElements.get('sga-quantity-breaks')) {
  var SgaQuantityBreaks = function (_HTMLElement) {
    function SgaQuantityBreaks() {
      _quantity_breaks_classCallCheck(this, SgaQuantityBreaks);
      return _callSuper(this, SgaQuantityBreaks, arguments);
    }
    _inherits(SgaQuantityBreaks, _HTMLElement);
    return _quantity_breaks_createClass(SgaQuantityBreaks, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        this.productId = this.getAttribute('data-product-id');
        this.init();
      }
    }, {
      key: "updateMainProductPrice",
      value: function updateMainProductPrice() {
        var intelliGemsPrice = getIntelligemsPrice(this.productId);
        if (!intelliGemsPrice) return;
        var productPriceElement = document.querySelector('[data-product-detail-price] [data-cart-price-value]');
        if (productPriceElement) {
          productPriceElement.innerHTML = Shopify.formatMoney(intelliGemsPrice);
        }
      }
    }, {
      key: "updateQuantityBreakPrices",
      value: function updateQuantityBreakPrices() {
        var intelliGemsPrice = getIntelligemsPrice(this.productId);
        if (!intelliGemsPrice) return;
        this.querySelectorAll('[data-quantity-breaks-json]').forEach(function (jsonElement, index) {
          var rowData = JSON.parse(jsonElement.textContent);
          var quantity = rowData.quantity;
          var discountPercent = rowData.discount_percent || 0;
          var regularTotal = intelliGemsPrice * quantity;
          var discountAmount = Math.floor(regularTotal * discountPercent / 100);
          var discountedTotal = regularTotal - discountAmount;
          var pricePerUnit = discountPercent > 0 ? Math.ceil(discountedTotal / quantity) : intelliGemsPrice;
          rowData.price_per_unit_original_raw = index === 0 ? null : intelliGemsPrice;
          rowData.price_per_unit_raw = pricePerUnit;
          rowData.total_price_raw = discountedTotal;
          rowData.savings_amount = discountAmount;
          jsonElement.textContent = JSON.stringify(rowData);
          var row = jsonElement.closest('[data-quantity-breaks-row]');
          if (row) {
            var unitPriceElement = row.querySelector('.quantity-breaks__unit-price');
            if (unitPriceElement) {
              var existingSup = unitPriceElement.querySelector('sup');
              var pieceText = existingSup ? existingSup.textContent : '/kus';
              var formattedPrice = Shopify.formatMoney(pricePerUnit);
              unitPriceElement.innerHTML = formattedPrice + '<sup>' + pieceText + '</sup>';
            }
            if (discountAmount > 0) {
              var savingsElement = row.querySelector('.quantity-breaks__savings .whitespace-nowrap');
              if (savingsElement) {
                savingsElement.innerHTML = Shopify.formatMoney(discountAmount);
              }
            }
          }
        });
      }
    }, {
      key: "init",
      value: function init() {
        var _this = this;
        waitForIntelligems(function () {
          _this.updateQuantityBreakPrices();
          _this.updateMainProductPrice();
        });
        this.querySelectorAll('[data-quantity-breaks-row]').forEach(function (row) {
          row.onclick = null;
        });
        this.querySelectorAll('[name="quantity-option"]').forEach(function (radio) {
          radio.onchange = null;
        });
        this.querySelectorAll('[data-quantity-breaks-row]').forEach(function (row) {
          row.addEventListener('click', function (e) {
            if (e.target.type === 'radio') return;
            var radio = row.querySelector('[name="quantity-option"]');
            var label = row.querySelector('label');
            if (label && radio) {
              label.click();
              radio.checked = true;
              radio.dispatchEvent(new Event('change'));
            }
          });
        });
        this.querySelectorAll('[name="quantity-option"]').forEach(function (radio) {
          radio.addEventListener('change', function (e) {
            var _e$detail, _e$detail2;
            var quantity = ((_e$detail = e.detail) === null || _e$detail === void 0 ? void 0 : _e$detail.quantityValue) || parseInt(e.target.value);
            var quantityBreaksRowElement = e.target.closest('[data-quantity-breaks-row]');
            var productForm = _this.closest('product-form') || _this.closest('[data-product-add-to-cart]');
            var quantityInputContainer = (productForm === null || productForm === void 0 ? void 0 : productForm.querySelector('[data-quantity-input]')) || document.querySelector('[data-quantity-input]');
            if (quantityInputContainer) {
              var quantityInputMinus = quantityInputContainer.querySelector('button[name="minus"]');
              var quantityInputPlus = quantityInputContainer.querySelector('button[name="plus"]');
              var quantityInput = quantityInputContainer.querySelector('.qty-input__input');
              if (quantityInputMinus) {
                quantityInputMinus.disabled = quantity <= 1;
              }
              if (quantityInputPlus && quantityInput) {
                var max = Number(quantityInput.max) || 0;
                quantityInputPlus.disabled = max > 0 && quantity >= max;
              }
            }
            var rowData = JSON.parse(quantityBreaksRowElement.querySelector('[data-quantity-breaks-json]').textContent);
            var intelliGemsPrice = getIntelligemsPrice(_this.productId);
            var basePrice = intelliGemsPrice || Number(rowData.price_per_unit_original_raw);
            var totalPrice, regularPrice;
            if (intelliGemsPrice) {
              var discountPercent = Number(rowData.discount_percent) || 0;
              var regularTotal = basePrice * Number(quantity);
              var discountAmount = Math.floor(regularTotal * discountPercent / 100);
              var discountedTotal = regularTotal - discountAmount;
              totalPrice = Shopify.formatMoney(discountedTotal);
              regularPrice = rowData.price_per_unit_original_raw === null ? '' : Shopify.formatMoney(regularTotal);
            } else {
              totalPrice = Shopify.formatMoney(Number(rowData.total_price_raw));
              regularPrice = rowData.price_per_unit_original_raw === null ? '' : Shopify.formatMoney(Number(rowData.price_per_unit_original_raw) * Number(quantity));
            }
            var savingsAmount = Shopify.formatMoney(rowData.savings_amount);
            document.querySelector('[data-cart-quantity-input]').value = quantity;
            document.querySelector('[data-product-detail-price] [data-cart-price-value]').innerHTML = totalPrice;
            document.querySelector('[data-product-detail-price] [data-cart-price-was-value]').innerHTML = regularPrice;
            document.querySelector('[data-product-detail-price] [data-cart-discount-percent-value]').innerHTML = rowData.discount_percent;
            document.querySelector('[data-product-detail-price] [data-cart-discount-value]').innerHTML = savingsAmount;
            document.querySelector('[data-product-detail-price] [data-cart-discount-element]').classList.toggle('!hidden', Number(rowData.index) === 0);
            if (!((_e$detail2 = e.detail) !== null && _e$detail2 !== void 0 && _e$detail2.quantityValue)) {
              document.querySelectorAll('.quantity-breaks__row').forEach(function (row) {
                var match = row.querySelector("#qty-".concat(quantity));
                row.classList.toggle('selected', !!match);
                row.querySelector('input').dataset.lastInputValue = quantity;
              });
            }
            window.globals.updateQuickFacts(quantity, rowData);
          });
        });
        var firstRadio = this.querySelector('[name="quantity-option"]:checked');
        if (firstRadio) {
          var firstRow = firstRadio.closest('.quantity-breaks__row');
          firstRow.classList.add('selected');
        }
      }
    }]);
  }(_wrapNativeSuper(HTMLElement));
  customElements.define('sga-quantity-breaks', SgaQuantityBreaks);
}
;// ./js/partials/_product-card-mini-price-update.js
function _product_card_mini_price_update_typeof(o) { "@babel/helpers - typeof"; return _product_card_mini_price_update_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _product_card_mini_price_update_typeof(o); }
function _product_card_mini_price_update_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _product_card_mini_price_update_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _product_card_mini_price_update_toPropertyKey(o.key), o); } }
function _product_card_mini_price_update_createClass(e, r, t) { return r && _product_card_mini_price_update_defineProperties(e.prototype, r), t && _product_card_mini_price_update_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _product_card_mini_price_update_toPropertyKey(t) { var i = _product_card_mini_price_update_toPrimitive(t, "string"); return "symbol" == _product_card_mini_price_update_typeof(i) ? i : i + ""; }
function _product_card_mini_price_update_toPrimitive(t, r) { if ("object" != _product_card_mini_price_update_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _product_card_mini_price_update_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _product_card_mini_price_update_callSuper(t, o, e) { return o = _product_card_mini_price_update_getPrototypeOf(o), _product_card_mini_price_update_possibleConstructorReturn(t, _product_card_mini_price_update_isNativeReflectConstruct() ? Reflect.construct(o, e || [], _product_card_mini_price_update_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _product_card_mini_price_update_possibleConstructorReturn(t, e) { if (e && ("object" == _product_card_mini_price_update_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _product_card_mini_price_update_assertThisInitialized(t); }
function _product_card_mini_price_update_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _product_card_mini_price_update_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _product_card_mini_price_update_setPrototypeOf(t, e); }
function _product_card_mini_price_update_wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _product_card_mini_price_update_wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_product_card_mini_price_update_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _product_card_mini_price_update_construct(t, arguments, _product_card_mini_price_update_getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _product_card_mini_price_update_setPrototypeOf(Wrapper, t); }, _product_card_mini_price_update_wrapNativeSuper(t); }
function _product_card_mini_price_update_construct(t, e, r) { if (_product_card_mini_price_update_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _product_card_mini_price_update_setPrototypeOf(p, r.prototype), p; }
function _product_card_mini_price_update_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_product_card_mini_price_update_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _product_card_mini_price_update_isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _product_card_mini_price_update_setPrototypeOf(t, e) { return _product_card_mini_price_update_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _product_card_mini_price_update_setPrototypeOf(t, e); }
function _product_card_mini_price_update_getPrototypeOf(t) { return _product_card_mini_price_update_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _product_card_mini_price_update_getPrototypeOf(t); }

var SgaProductCardMiniPriceUpdate = function (_HTMLElement) {
  function SgaProductCardMiniPriceUpdate() {
    _product_card_mini_price_update_classCallCheck(this, SgaProductCardMiniPriceUpdate);
    return _product_card_mini_price_update_callSuper(this, SgaProductCardMiniPriceUpdate, arguments);
  }
  _product_card_mini_price_update_inherits(SgaProductCardMiniPriceUpdate, _HTMLElement);
  return _product_card_mini_price_update_createClass(SgaProductCardMiniPriceUpdate, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.productId = this.getAttribute('data-product-id');
      this.nextDiscount = parseFloat(this.getAttribute('data-next-discount')) || 0;
      if (this.productId && this.nextDiscount > 0) {
        this.init();
      }
    }
  }, {
    key: "init",
    value: function init() {
      var _this = this;
      waitForIntelligems(function () {
        _this.updateQuantityBreakPrices();
      });
    }
  }, {
    key: "updateQuantityBreakPrices",
    value: function updateQuantityBreakPrices() {
      var intelliGemsPrice = getIntelligemsPrice(this.productId);
      if (!intelliGemsPrice) return;
      var currentPriceElement = this.querySelector('[data-cart-price-value]');
      var wasPriceElement = this.querySelector('[data-cart-price-was-value]');
      if (!currentPriceElement || !wasPriceElement) return;
      var discountMultiplier = (100 - this.nextDiscount) / 100;
      var newPrice = intelliGemsPrice * discountMultiplier;
      var formattedNewPrice = Shopify.formatMoney(newPrice);
      var formattedOriginalPrice = Shopify.formatMoney(intelliGemsPrice);
      currentPriceElement.innerHTML = formattedNewPrice;
      wasPriceElement.innerHTML = formattedOriginalPrice;
    }
  }]);
}(_product_card_mini_price_update_wrapNativeSuper(HTMLElement));
if (!customElements.get('sga-product-card-mini-price-update')) {
  customElements.define('sga-product-card-mini-price-update', SgaProductCardMiniPriceUpdate);
}

;// ./js/partials/_price-range.js
function _price_range_typeof(o) { "@babel/helpers - typeof"; return _price_range_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _price_range_typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _price_range_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _price_range_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_price_range_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _price_range_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _price_range_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _price_range_toPropertyKey(o.key), o); } }
function _price_range_createClass(e, r, t) { return r && _price_range_defineProperties(e.prototype, r), t && _price_range_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _price_range_toPropertyKey(t) { var i = _price_range_toPrimitive(t, "string"); return "symbol" == _price_range_typeof(i) ? i : i + ""; }
function _price_range_toPrimitive(t, r) { if ("object" != _price_range_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _price_range_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _price_range_callSuper(t, o, e) { return o = _price_range_getPrototypeOf(o), _price_range_possibleConstructorReturn(t, _price_range_isNativeReflectConstruct() ? Reflect.construct(o, e || [], _price_range_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _price_range_possibleConstructorReturn(t, e) { if (e && ("object" == _price_range_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _price_range_assertThisInitialized(t); }
function _price_range_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _price_range_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _price_range_setPrototypeOf(t, e); }
function _price_range_wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _price_range_wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_price_range_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _price_range_construct(t, arguments, _price_range_getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _price_range_setPrototypeOf(Wrapper, t); }, _price_range_wrapNativeSuper(t); }
function _price_range_construct(t, e, r) { if (_price_range_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _price_range_setPrototypeOf(p, r.prototype), p; }
function _price_range_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_price_range_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _price_range_isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _price_range_setPrototypeOf(t, e) { return _price_range_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _price_range_setPrototypeOf(t, e); }
function _price_range_getPrototypeOf(t) { return _price_range_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _price_range_getPrototypeOf(t); }

if (!customElements.get('price-range')) {
  var PriceRange = function (_HTMLElement) {
    function PriceRange() {
      var _this;
      _price_range_classCallCheck(this, PriceRange);
      _this = _price_range_callSuper(this, PriceRange);
      window.initLazyScript(_this, _this.init.bind(_this));
      return _this;
    }
    _price_range_inherits(PriceRange, _HTMLElement);
    return _price_range_createClass(PriceRange, [{
      key: "init",
      value: function init() {
        this.minNumberInput = document.getElementById('price-range-number-min');
        this.maxNumberInput = document.getElementById('price-range-number-max');
        this.minSliderInput = document.getElementById('price-range-slider-min');
        this.maxSliderInput = document.getElementById('price-range-slider-max');
        this.minValue = Number(this.minNumberInput.min);
        this.maxValue = Number(this.maxNumberInput.max);
        this.timeout = null;
        this.addEventListener('input', this.handleInput.bind(this));
        this.calculateRealPriceRange();
      }
    }, {
      key: "handleInput",
      value: function handleInput(evt) {
        var _this2 = this;
        if (evt.detail !== undefined) {
          clearTimeout(this.timeout);
          this.timeout = setTimeout(function () {
            _this2.updateSliderInputs(evt);
            _this2.updateNumberInputs();
          }, 500);
        } else {
          this.updateSliderInputs(evt);
          this.updateNumberInputs();
        }
      }
    }, {
      key: "updateNumberInputs",
      value: function updateNumberInputs() {
        this.minNumberInput.value = this.minSliderInput.value !== this.minNumberInput.min ? this.minSliderInput.value : null;
        this.maxNumberInput.value = this.maxSliderInput.value !== this.maxNumberInput.max ? this.maxSliderInput.value : null;
      }
    }, {
      key: "updateSliderInputs",
      value: function updateSliderInputs(evt) {
        var minValue = parseInt(this.minNumberInput.value, 10);
        var maxValue = parseInt(this.maxNumberInput.value, 10);
        if (minValue > maxValue - 10) {
          if (evt.target === this.minNumberInput) {
            this.maxSliderInput.value = minValue + 10;
            if (maxValue === this.maxValue) {
              this.minSliderInput.value = this.maxValue - 10;
            }
          } else {
            this.minSliderInput.value = maxValue - 10;
          }
        }
        if (maxValue < minValue + 10) {
          if (evt.target === this.maxNumberInput) {
            this.minSliderInput.value = maxValue - 10;
            if (minValue === this.minValue) {
              this.maxSliderInput.value = 10;
            }
          } else {
            this.maxSliderInput.value = minValue + 10;
          }
        }
        if (evt.target === this.minNumberInput) {
          this.minSliderInput.value = minValue || Number(this.minNumberInput.min);
        }
        if (evt.target === this.maxNumberInput) {
          this.maxSliderInput.value = maxValue || Number(this.maxNumberInput.max);
        }
      }
    }, {
      key: "calculateRealPriceRange",
      value: (function () {
        var _calculateRealPriceRange = _asyncToGenerator(_regeneratorRuntime().mark(function _callee2() {
          var _this3 = this;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                waitForIntelligems(_asyncToGenerator(_regeneratorRuntime().mark(function _callee() {
                  var searchTerms, products, realPrices, _iterator, _step, product, _iterator2, _step2, variant, variantId, originalPrice, intelligemsPrice, finalPrice, realMin, realMax;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        searchTerms = _this3.getAttribute('data-search-terms') || '';
                        _context.prev = 1;
                        if (!searchTerms) {
                          _context.next = 8;
                          break;
                        }
                        _context.next = 5;
                        return _this3.getAllProductsFromSearch(searchTerms);
                      case 5:
                        _context.t0 = _context.sent;
                        _context.next = 11;
                        break;
                      case 8:
                        _context.next = 10;
                        return _this3.getAllProductsFromCollection();
                      case 10:
                        _context.t0 = _context.sent;
                      case 11:
                        products = _context.t0;
                        if (!(!products || products.length === 0)) {
                          _context.next = 14;
                          break;
                        }
                        return _context.abrupt("return");
                      case 14:
                        realPrices = [];
                        _iterator = _createForOfIteratorHelper(products);
                        try {
                          for (_iterator.s(); !(_step = _iterator.n()).done;) {
                            product = _step.value;
                            if (product.variants && product.variants.nodes) {
                              _iterator2 = _createForOfIteratorHelper(product.variants.nodes);
                              try {
                                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                                  variant = _step2.value;
                                  if (variant.priceV2) {
                                    variantId = variant.id.split('/').pop();
                                    originalPrice = parseFloat(variant.priceV2.amount);
                                    intelligemsPrice = getIntelligemsPrice(variantId);
                                    finalPrice = void 0;
                                    if (intelligemsPrice) {
                                      finalPrice = intelligemsPrice / 100;
                                    } else {
                                      finalPrice = originalPrice;
                                    }
                                    realPrices.push(finalPrice);
                                  }
                                }
                              } catch (err) {
                                _iterator2.e(err);
                              } finally {
                                _iterator2.f();
                              }
                            }
                          }
                        } catch (err) {
                          _iterator.e(err);
                        } finally {
                          _iterator.f();
                        }
                        if (realPrices.length > 0) {
                          realMin = Math.min.apply(Math, realPrices);
                          realMax = Math.max.apply(Math, realPrices);
                          _this3.updatePriceRange(realMin, realMax);
                        }
                        _context.next = 23;
                        break;
                      case 20:
                        _context.prev = 20;
                        _context.t1 = _context["catch"](1);
                        console.error('Error calculating real price range:', _context.t1);
                      case 23:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee, null, [[1, 20]]);
                })));
              case 1:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function calculateRealPriceRange() {
          return _calculateRealPriceRange.apply(this, arguments);
        }
        return calculateRealPriceRange;
      }())
    }, {
      key: "fetchProductsWithPagination",
      value: (function () {
        var _fetchProductsWithPagination = _asyncToGenerator(_regeneratorRuntime().mark(function _callee3(query, getVariables, extractProducts) {
          var _window$theme;
          var storefrontToken, allProducts, hasNextPage, cursor, variables, response, data, result;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                storefrontToken = (_window$theme = window.theme) === null || _window$theme === void 0 || (_window$theme = _window$theme.settings) === null || _window$theme === void 0 ? void 0 : _window$theme.storefrontApiToken;
                allProducts = [];
                hasNextPage = true;
                cursor = null;
                _context3.prev = 4;
              case 5:
                if (!hasNextPage) {
                  _context3.next = 23;
                  break;
                }
                variables = getVariables(cursor);
                _context3.next = 9;
                return fetch('/api/2024-10/graphql.json', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': storefrontToken
                  },
                  body: JSON.stringify({
                    query: query,
                    variables: variables
                  })
                });
              case 9:
                response = _context3.sent;
                _context3.next = 12;
                return response.json();
              case 12:
                data = _context3.sent;
                if (!data.errors) {
                  _context3.next = 15;
                  break;
                }
                return _context3.abrupt("return", allProducts);
              case 15:
                result = extractProducts(data);
                if (result) {
                  _context3.next = 18;
                  break;
                }
                return _context3.abrupt("return", allProducts);
              case 18:
                allProducts.push.apply(allProducts, _toConsumableArray(result.nodes));
                hasNextPage = result.pageInfo.hasNextPage;
                cursor = result.pageInfo.endCursor;
                _context3.next = 5;
                break;
              case 23:
                return _context3.abrupt("return", allProducts);
              case 26:
                _context3.prev = 26;
                _context3.t0 = _context3["catch"](4);
                return _context3.abrupt("return", []);
              case 29:
              case "end":
                return _context3.stop();
            }
          }, _callee3, null, [[4, 26]]);
        }));
        function fetchProductsWithPagination(_x, _x2, _x3) {
          return _fetchProductsWithPagination.apply(this, arguments);
        }
        return fetchProductsWithPagination;
      }())
    }, {
      key: "getAllProductsFromSearch",
      value: (function () {
        var _getAllProductsFromSearch = _asyncToGenerator(_regeneratorRuntime().mark(function _callee4(searchTerms) {
          var query, getVariables, extractProducts;
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                query = "\n        query searchProducts($query: String!, $first: Int!, $after: String) {\n          search(query: $query, first: $first, after: $after, types: [PRODUCT]) {\n            nodes {\n              ... on Product {\n                variants(first: 250) {\n                  nodes {\n                    id\n                    priceV2 {\n                      amount\n                    }\n                  }\n                }\n              }\n            }\n            pageInfo {\n              hasNextPage\n              endCursor\n            }\n          }\n        }\n      ";
                getVariables = function getVariables(cursor) {
                  return _objectSpread({
                    query: searchTerms || '*',
                    first: 250
                  }, cursor && {
                    after: cursor
                  });
                };
                extractProducts = function extractProducts(data) {
                  return data.data.search;
                };
                return _context4.abrupt("return", this.fetchProductsWithPagination(query, getVariables, extractProducts));
              case 4:
              case "end":
                return _context4.stop();
            }
          }, _callee4, this);
        }));
        function getAllProductsFromSearch(_x4) {
          return _getAllProductsFromSearch.apply(this, arguments);
        }
        return getAllProductsFromSearch;
      }())
    }, {
      key: "getAllProductsFromCollection",
      value: (function () {
        var _getAllProductsFromCollection = _asyncToGenerator(_regeneratorRuntime().mark(function _callee5() {
          var _window$location$path;
          var collectionHandle, query, getVariables, extractProducts;
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                collectionHandle = (_window$location$path = window.location.pathname.split('/collections/')[1]) === null || _window$location$path === void 0 ? void 0 : _window$location$path.split('/')[0];
                if (collectionHandle) {
                  _context5.next = 3;
                  break;
                }
                return _context5.abrupt("return", []);
              case 3:
                query = "\n        query getCollectionProducts($handle: String!, $first: Int!, $after: String) {\n          collectionByHandle(handle: $handle) {\n            products(first: $first, after: $after) {\n              nodes {\n                variants(first: 250) {\n                  nodes {\n                    id\n                    priceV2 {\n                      amount\n                    }\n                  }\n                }\n              }\n              pageInfo {\n                hasNextPage\n                endCursor\n              }\n            }\n          }\n        }\n      ";
                getVariables = function getVariables(cursor) {
                  return _objectSpread({
                    handle: collectionHandle,
                    first: 250
                  }, cursor && {
                    after: cursor
                  });
                };
                extractProducts = function extractProducts(data) {
                  var _data$data$collection;
                  return (_data$data$collection = data.data.collectionByHandle) === null || _data$data$collection === void 0 ? void 0 : _data$data$collection.products;
                };
                return _context5.abrupt("return", this.fetchProductsWithPagination(query, getVariables, extractProducts));
              case 7:
              case "end":
                return _context5.stop();
            }
          }, _callee5, this);
        }));
        function getAllProductsFromCollection() {
          return _getAllProductsFromCollection.apply(this, arguments);
        }
        return getAllProductsFromCollection;
      }())
    }, {
      key: "updatePriceRange",
      value: function updatePriceRange(newMin, newMax) {
        var currentMin = this.minValue;
        var currentMax = this.maxValue;
        var roundedMin = Math.floor(newMin);
        var roundedMax = Math.ceil(newMax);
        if (roundedMin !== currentMin || roundedMax !== currentMax) {
          this.minValue = roundedMin;
          this.maxValue = roundedMax;
          this.minNumberInput.setAttribute('min', roundedMin);
          this.minNumberInput.setAttribute('placeholder', roundedMin);
          this.minSliderInput.setAttribute('min', roundedMin);
          this.maxSliderInput.setAttribute('min', roundedMin);
          this.maxNumberInput.setAttribute('max', roundedMax);
          this.maxNumberInput.setAttribute('placeholder', roundedMax);
          this.maxSliderInput.setAttribute('max', roundedMax);
          this.minSliderInput.setAttribute('max', roundedMax);
          if (parseInt(this.minSliderInput.value) < roundedMin) {
            this.minSliderInput.value = roundedMin;
          }
          if (parseInt(this.maxSliderInput.value) > roundedMax) {
            this.maxSliderInput.value = roundedMax;
            this.maxNumberInput.value = '';
          }
        }
      }
    }]);
  }(_price_range_wrapNativeSuper(HTMLElement));
  customElements.define('price-range', PriceRange);
}
;// ./js/partials/_sga-price.js
function _sga_price_typeof(o) { "@babel/helpers - typeof"; return _sga_price_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _sga_price_typeof(o); }
function _sga_price_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _sga_price_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _sga_price_toPropertyKey(o.key), o); } }
function _sga_price_createClass(e, r, t) { return r && _sga_price_defineProperties(e.prototype, r), t && _sga_price_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _sga_price_toPropertyKey(t) { var i = _sga_price_toPrimitive(t, "string"); return "symbol" == _sga_price_typeof(i) ? i : i + ""; }
function _sga_price_toPrimitive(t, r) { if ("object" != _sga_price_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _sga_price_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _sga_price_callSuper(t, o, e) { return o = _sga_price_getPrototypeOf(o), _sga_price_possibleConstructorReturn(t, _sga_price_isNativeReflectConstruct() ? Reflect.construct(o, e || [], _sga_price_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _sga_price_possibleConstructorReturn(t, e) { if (e && ("object" == _sga_price_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _sga_price_assertThisInitialized(t); }
function _sga_price_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _sga_price_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _sga_price_setPrototypeOf(t, e); }
function _sga_price_wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _sga_price_wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_sga_price_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _sga_price_construct(t, arguments, _sga_price_getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _sga_price_setPrototypeOf(Wrapper, t); }, _sga_price_wrapNativeSuper(t); }
function _sga_price_construct(t, e, r) { if (_sga_price_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _sga_price_setPrototypeOf(p, r.prototype), p; }
function _sga_price_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_sga_price_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _sga_price_isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _sga_price_setPrototypeOf(t, e) { return _sga_price_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _sga_price_setPrototypeOf(t, e); }
function _sga_price_getPrototypeOf(t) { return _sga_price_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _sga_price_getPrototypeOf(t); }

var SgaPrice = function (_HTMLElement) {
  function SgaPrice() {
    _sga_price_classCallCheck(this, SgaPrice);
    return _sga_price_callSuper(this, SgaPrice, arguments);
  }
  _sga_price_inherits(SgaPrice, _HTMLElement);
  return _sga_price_createClass(SgaPrice, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.variantId = this.getAttribute('data-variant-id');
      if (this.variantId) {
        this.init();
      }
    }
  }, {
    key: "init",
    value: function init() {
      var _this = this;
      waitForIntelligems(function () {
        _this.updateIntelligemsPrice();
      });
    }
  }, {
    key: "formatPrice",
    value: function formatPrice(priceInCents) {
      if (priceInCents == null) return '';
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(priceInCents);
      }
      return (Number(priceInCents) / 100).toFixed(2);
    }
  }, {
    key: "updateIntelligemsPrice",
    value: function updateIntelligemsPrice() {
      var intelliGemsPrice = this.variantId ? getIntelligemsPrice(this.variantId) : null;
      if (intelliGemsPrice == null) return;
      var currentPriceElement = this.querySelector('[data-cart-price-value]');
      if (!currentPriceElement) return;
      currentPriceElement.innerHTML = this.formatPrice(intelliGemsPrice);
      if (typeof this.updateDiscountBlocks === 'function') {
        this.updateDiscountBlocks(intelliGemsPrice);
      }
    }
  }]);
}(_sga_price_wrapNativeSuper(HTMLElement));
if (!customElements.get('sga-price')) {
  customElements.define('sga-price', SgaPrice);
}

;// ./js/partials/_sga-variant-select.js
function _sga_variant_select_typeof(o) { "@babel/helpers - typeof"; return _sga_variant_select_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _sga_variant_select_typeof(o); }
function _sga_variant_select_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _sga_variant_select_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _sga_variant_select_toPropertyKey(o.key), o); } }
function _sga_variant_select_createClass(e, r, t) { return r && _sga_variant_select_defineProperties(e.prototype, r), t && _sga_variant_select_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _sga_variant_select_toPropertyKey(t) { var i = _sga_variant_select_toPrimitive(t, "string"); return "symbol" == _sga_variant_select_typeof(i) ? i : i + ""; }
function _sga_variant_select_toPrimitive(t, r) { if ("object" != _sga_variant_select_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _sga_variant_select_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _sga_variant_select_callSuper(t, o, e) { return o = _sga_variant_select_getPrototypeOf(o), _sga_variant_select_possibleConstructorReturn(t, _sga_variant_select_isNativeReflectConstruct() ? Reflect.construct(o, e || [], _sga_variant_select_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _sga_variant_select_possibleConstructorReturn(t, e) { if (e && ("object" == _sga_variant_select_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _sga_variant_select_assertThisInitialized(t); }
function _sga_variant_select_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _sga_variant_select_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _sga_variant_select_setPrototypeOf(t, e); }
function _sga_variant_select_wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _sga_variant_select_wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_sga_variant_select_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _sga_variant_select_construct(t, arguments, _sga_variant_select_getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _sga_variant_select_setPrototypeOf(Wrapper, t); }, _sga_variant_select_wrapNativeSuper(t); }
function _sga_variant_select_construct(t, e, r) { if (_sga_variant_select_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _sga_variant_select_setPrototypeOf(p, r.prototype), p; }
function _sga_variant_select_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_sga_variant_select_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _sga_variant_select_isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _sga_variant_select_setPrototypeOf(t, e) { return _sga_variant_select_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _sga_variant_select_setPrototypeOf(t, e); }
function _sga_variant_select_getPrototypeOf(t) { return _sga_variant_select_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _sga_variant_select_getPrototypeOf(t); }

if (!customElements.get('sga-variant-select')) {
  var SgaVariantSelect = function (_HTMLElement) {
    function SgaVariantSelect() {
      _sga_variant_select_classCallCheck(this, SgaVariantSelect);
      return _sga_variant_select_callSuper(this, SgaVariantSelect);
    }
    _sga_variant_select_inherits(SgaVariantSelect, _HTMLElement);
    return _sga_variant_select_createClass(SgaVariantSelect, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this = this;
        this.init();
        waitForIntelligems(function () {
          _this.updateIntelligemsPrices();
        });
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        this.cleanup();
        this._initialized = false;
      }
    }, {
      key: "init",
      value: function init() {
        var _this2 = this;
        if (this._initialized) {
          this.cleanup();
        }
        var selected = this.querySelector('[data-sga-variant-select-selected]');
        var variants = this.querySelector('[data-sga-variant-select-variants]');
        var variantItems = this.querySelectorAll('[data-sga-variant-select-variants-item]');
        if (!selected || !variants || !variantItems.length) return;
        this._selected = selected;
        this._variants = variants;
        this._variantItems = variantItems;
        var updateHiddenItems = function updateHiddenItems() {
          var _selected$querySelect;
          var selectedContent = ((_selected$querySelect = selected.querySelector('.sga-variant-select-content')) === null || _selected$querySelect === void 0 ? void 0 : _selected$querySelect.outerHTML) || '';
          variantItems.forEach(function (item) {
            var _item$querySelector;
            var itemContent = ((_item$querySelector = item.querySelector('.sga-variant-select-content')) === null || _item$querySelector === void 0 ? void 0 : _item$querySelector.outerHTML) || '';
            if (itemContent === selectedContent) {
              item.classList.add('hidden');
            } else {
              item.classList.remove('hidden');
            }
          });
        };
        selected.onclick = null;
        variantItems.forEach(function (item) {
          return item.onclick = null;
        });
        this._selectedClickHandler = function (e) {
          selected.parentElement.classList.toggle('isOpen');
          e.stopPropagation();
        };
        selected.addEventListener('click', this._selectedClickHandler);
        this._bodyClickHandler = function (e) {
          if (!_this2.contains(e.target)) {
            selected.parentElement.classList.remove('isOpen');
          }
        };
        document.body.addEventListener('click', this._bodyClickHandler);
        this._variantClickHandlers = [];
        variantItems.forEach(function (item) {
          var handler = function handler(e) {
            var variantContent = item.querySelector('.sga-variant-select-content');
            var selectedContentEl = selected.querySelector('.sga-variant-select-content');
            if (variantContent && selectedContentEl) {
              selectedContentEl.outerHTML = variantContent.outerHTML;
            }
            selected.setAttribute('data-product-id', item.getAttribute('data-product-id'));
            selected.setAttribute('data-product-handle', item.getAttribute('data-product-handle'));
            selected.parentElement.classList.remove('isOpen');
            e.stopPropagation();
            updateHiddenItems();
            _this2._updateIntelligemsPrice(selected);
            var event = new Event('change', {
              bubbles: true
            });
            selected.dispatchEvent(event);
          };
          _this2._variantClickHandlers.push({
            item: item,
            handler: handler
          });
          item.addEventListener('click', handler);
        });
        updateHiddenItems();
        this._initialized = true;
      }
    }, {
      key: "_updateIntelligemsPrice",
      value: function _updateIntelligemsPrice(element) {
        if (!element) return;
        var priceElement = element.querySelector('[data-sga-variant-price]');
        if (priceElement) {
          var variantId = priceElement.getAttribute('data-variant-id');
          if (variantId) {
            var intelliGemsPrice = getIntelligemsPrice(variantId);
            if (intelliGemsPrice) {
              priceElement.innerHTML = Shopify.formatMoney(intelliGemsPrice);
            }
          }
        }
      }
    }, {
      key: "updateIntelligemsPrices",
      value: function updateIntelligemsPrices() {
        var _this3 = this;
        if (!this._selected && !this._variantItems) return;
        if (this._selected) {
          this._updateIntelligemsPrice(this._selected);
        }
        if (this._variantItems) {
          this._variantItems.forEach(function (item) {
            _this3._updateIntelligemsPrice(item);
          });
        }
      }
    }, {
      key: "cleanup",
      value: function cleanup() {
        if (this._bodyClickHandler) {
          document.body.removeEventListener('click', this._bodyClickHandler);
          this._bodyClickHandler = null;
        }
        if (this._selected && this._selectedClickHandler) {
          this._selected.removeEventListener('click', this._selectedClickHandler);
          this._selectedClickHandler = null;
        }
        if (this._variantClickHandlers) {
          this._variantClickHandlers.forEach(function (_ref) {
            var item = _ref.item,
              handler = _ref.handler;
            item.removeEventListener('click', handler);
          });
          this._variantClickHandlers = [];
        }
        this._selected = null;
        this._variants = null;
        this._variantItems = null;
      }
    }]);
  }(_sga_variant_select_wrapNativeSuper(HTMLElement));
  customElements.define('sga-variant-select', SgaVariantSelect);
}
;// ./js/partials/_sga-variant-picker.js
function _sga_variant_picker_typeof(o) { "@babel/helpers - typeof"; return _sga_variant_picker_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _sga_variant_picker_typeof(o); }
function _sga_variant_picker_regeneratorRuntime() { "use strict"; _sga_variant_picker_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _sga_variant_picker_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_sga_variant_picker_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _sga_variant_picker_asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _sga_variant_picker_asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { _sga_variant_picker_asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { _sga_variant_picker_asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _sga_variant_picker_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _sga_variant_picker_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _sga_variant_picker_toPropertyKey(o.key), o); } }
function _sga_variant_picker_createClass(e, r, t) { return r && _sga_variant_picker_defineProperties(e.prototype, r), t && _sga_variant_picker_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _sga_variant_picker_toPropertyKey(t) { var i = _sga_variant_picker_toPrimitive(t, "string"); return "symbol" == _sga_variant_picker_typeof(i) ? i : i + ""; }
function _sga_variant_picker_toPrimitive(t, r) { if ("object" != _sga_variant_picker_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _sga_variant_picker_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _sga_variant_picker_callSuper(t, o, e) { return o = _sga_variant_picker_getPrototypeOf(o), _sga_variant_picker_possibleConstructorReturn(t, _sga_variant_picker_isNativeReflectConstruct() ? Reflect.construct(o, e || [], _sga_variant_picker_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _sga_variant_picker_possibleConstructorReturn(t, e) { if (e && ("object" == _sga_variant_picker_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _sga_variant_picker_assertThisInitialized(t); }
function _sga_variant_picker_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _sga_variant_picker_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _sga_variant_picker_setPrototypeOf(t, e); }
function _sga_variant_picker_wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _sga_variant_picker_wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_sga_variant_picker_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _sga_variant_picker_construct(t, arguments, _sga_variant_picker_getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _sga_variant_picker_setPrototypeOf(Wrapper, t); }, _sga_variant_picker_wrapNativeSuper(t); }
function _sga_variant_picker_construct(t, e, r) { if (_sga_variant_picker_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _sga_variant_picker_setPrototypeOf(p, r.prototype), p; }
function _sga_variant_picker_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_sga_variant_picker_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _sga_variant_picker_isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _sga_variant_picker_setPrototypeOf(t, e) { return _sga_variant_picker_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _sga_variant_picker_setPrototypeOf(t, e); }
function _sga_variant_picker_getPrototypeOf(t) { return _sga_variant_picker_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _sga_variant_picker_getPrototypeOf(t); }

if (!customElements.get('sga-variant-picker')) {
  var VariantPicker = function (_HTMLElement) {
    function VariantPicker() {
      var _this;
      _sga_variant_picker_classCallCheck(this, VariantPicker);
      _this = _sga_variant_picker_callSuper(this, VariantPicker);
      _this.section = _this.closest('.js-product');
      _this.productForm = _this.section.querySelector('.js-product-form-main');
      _this.data = _this.getProductData();
      _this.variant = _this.getSelectedVariant();
      _this.addEventListener('change', _this.handleVariantChange.bind(_this));
      return _this;
    }
    _sga_variant_picker_inherits(VariantPicker, _HTMLElement);
    return _sga_variant_picker_createClass(VariantPicker, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this2 = this;
        waitForIntelligems(function () {
          _this2.updateIntelligemsPrices();
        });
      }
    }, {
      key: "handleVariantChange",
      value: function handleVariantChange(evt) {
        var _evt$target$value, _this$data, _window$Shopify$route, _window$Shopify;
        var productHandle = (_evt$target$value = evt.target.value) !== null && _evt$target$value !== void 0 ? _evt$target$value : evt.target.dataset.productHandle;
        if (!productHandle || productHandle === ((_this$data = this.data) === null || _this$data === void 0 || (_this$data = _this$data.product) === null || _this$data === void 0 ? void 0 : _this$data.handle)) {
          return;
        }
        window.location.replace("".concat((_window$Shopify$route = (_window$Shopify = window.Shopify) === null || _window$Shopify === void 0 || (_window$Shopify = _window$Shopify.routes) === null || _window$Shopify === void 0 ? void 0 : _window$Shopify.root) !== null && _window$Shopify$route !== void 0 ? _window$Shopify$route : '/', "products/").concat(encodeURIComponent(productHandle)));
      }
    }, {
      key: "refreshTableWidgetSection",
      value: function refreshTableWidgetSection(productHandle) {
        var pageOrigin = window.location.origin;
        var sectionWrapper = document.querySelector('[id^="shopify-section-"].table-widget-section');
        if (!sectionWrapper) {
          return;
        }
        var sectionId = sectionWrapper.id.replace('shopify-section-', '');
        var url = "".concat(pageOrigin, "/products/").concat(productHandle, "?section_id=").concat(sectionId);
        fetch(url).then(function (res) {
          if (!res.ok) {
            throw new Error("Section fetch failed: ".concat(res.status, " ").concat(res.statusText));
          }
          return res.text();
        }).then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html.trim();
          var newSection = tmp.querySelector("#shopify-section-".concat(sectionId));
          if (newSection) {
            sectionWrapper.innerHTML = newSection.innerHTML;
          }
        }).catch(function (err) {
          console.error('[VariantPicker] Error refreshing table widget section:', err);
        });
      }
    }, {
      key: "fetchAndUpdateContent",
      value: function () {
        var _fetchAndUpdateContent = _sga_variant_picker_asyncToGenerator(_sga_variant_picker_regeneratorRuntime().mark(function _callee(pageUrl) {
          var productSection, templateSuffix, ajaxUrl, ajaxResponse, htmlText, parser, html, mainContent, oldMainContent, oldVariantPicker, newVariantPicker, currentUrl, currentParams, url, baseUrl, newUrl;
          return _sga_variant_picker_regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                if (pageUrl) {
                  _context.next = 4;
                  break;
                }
                console.error('[VariantPicker] No page URL provided for content update');
                return _context.abrupt("return", false);
              case 4:
                productSection = this.closest('.js-product');
                templateSuffix = productSection ? productSection.dataset.template : 'default';
                ajaxUrl = "".concat(pageUrl, "?view=").concat(templateSuffix, "&add-assets=false&lazy-load=false");
                _context.next = 9;
                return fetch(ajaxUrl);
              case 9:
                ajaxResponse = _context.sent;
                if (ajaxResponse.ok) {
                  _context.next = 13;
                  break;
                }
                console.error("[VariantPicker] Error fetching content: ".concat(ajaxResponse.status, " ").concat(ajaxResponse.statusText));
                return _context.abrupt("return", false);
              case 13:
                _context.next = 15;
                return ajaxResponse.text();
              case 15:
                htmlText = _context.sent;
                parser = new DOMParser();
                html = parser.parseFromString(htmlText, 'text/html');
                mainContent = html.querySelector('#main-content');
                if (mainContent) {
                  _context.next = 22;
                  break;
                }
                console.error('[VariantPicker] Could not find #main-content in the fetched HTML');
                return _context.abrupt("return", false);
              case 22:
                oldMainContent = document.querySelector('#main-content');
                if (oldMainContent) {
                  _context.next = 26;
                  break;
                }
                console.error('[VariantPicker] Could not find existing #main-content in the DOM');
                return _context.abrupt("return", false);
              case 26:
                oldVariantPicker = oldMainContent.querySelector('[data-sga-variant-picker]');
                oldMainContent.innerHTML = mainContent.innerHTML;
                if (oldVariantPicker) {
                  newVariantPicker = oldMainContent.querySelector('[data-sga-variant-picker]');
                  if (newVariantPicker && newVariantPicker.parentNode) {
                    newVariantPicker.parentNode.replaceChild(oldVariantPicker, newVariantPicker);
                  }
                }
                this.reinitializeJudgeMe();
                if (window.history && window.history.replaceState) {
                  currentUrl = new URL(window.location.href);
                  currentParams = new URLSearchParams(currentUrl.search);
                  url = new URL(pageUrl);
                  baseUrl = "".concat(url.origin).concat(url.pathname);
                  newUrl = new URL(baseUrl);
                  newUrl.search = currentParams.toString();
                  window.history.replaceState({}, '', newUrl.toString());
                }
                document.dispatchEvent(new CustomEvent('on:variant:content:updated', {
                  bubbles: true,
                  detail: {
                    pageUrl: pageUrl
                  }
                }));
                return _context.abrupt("return", true);
              case 35:
                _context.prev = 35;
                _context.t0 = _context["catch"](0);
                console.error('[VariantPicker] Error in fetchAndUpdateContent:', _context.t0);
                return _context.abrupt("return", false);
              case 39:
              case "end":
                return _context.stop();
            }
          }, _callee, this, [[0, 35]]);
        }));
        function fetchAndUpdateContent(_x) {
          return _fetchAndUpdateContent.apply(this, arguments);
        }
        return fetchAndUpdateContent;
      }()
    }, {
      key: "reinitializeJudgeMe",
      value: function reinitializeJudgeMe() {
        if (!window.jdgm) return;
        if (!window.jdgm.setupMediaGallery) {
          window.jdgm.setupMediaGallery = function (widget) {
            return widget;
          };
        }
        if (!window.jdgm._renderAndSetupReviewForm) {
          window.jdgm._renderAndSetupReviewForm = function (widget) {
            return widget;
          };
        }
        if (!window.jdgm._setupQuestionsForm) {
          window.jdgm._setupQuestionsForm = function (widget) {
            return widget;
          };
        }
        if (!window.jdgm._setupFormsSubmit) {
          window.jdgm._setupFormsSubmit = function (widget) {
            return widget;
          };
        }
        if (typeof window.jdgm.initializeWidgets === 'function') {
          window.jdgm.initializeWidgets();
        }
        if (typeof window.jdgm.initializeCarousel === 'function') {
          window.jdgm.initializeCarousel();
        }
      }
    }, {
      key: "getProductData",
      value: function getProductData() {
        try {
          var dataEl = this.querySelector('[type="application/json"]');
          if (!dataEl) {
            console.error('Variant Picker: No JSON data element found');
            return null;
          }
          var data = JSON.parse(dataEl.textContent);
          if (!data.product) {
            console.error('Variant Picker: Invalid product data structure', data);
            return data;
          }
          return data;
        } catch (error) {
          console.error('Variant Picker: Error parsing product data:', error);
          return null;
        }
      }
    }, {
      key: "getSelectedVariant",
      value: function getSelectedVariant(productId) {
        if (!productId) {
          return this.data.product;
        }
        return this.data.variants.find(function (variant) {
          return variant.id === productId;
        });
      }
    }, {
      key: "updateIntelligemsPrices",
      value: function updateIntelligemsPrices() {
        var priceElements = document.querySelectorAll('[data-variant-picker-price]');
        priceElements.forEach(function (priceElement) {
          var variantId = priceElement.getAttribute('data-variant-id');
          if (variantId) {
            var intelliGemsPrice = getIntelligemsPrice(variantId);
            if (intelliGemsPrice) {
              priceElement.innerHTML = Shopify.formatMoney(intelliGemsPrice);
            }
          }
        });
      }
    }]);
  }(_sga_variant_picker_wrapNativeSuper(HTMLElement));
  customElements.define('sga-variant-picker', VariantPicker);
}
;// ./js/helpers/_purchase-widget-pricing.js
function getProductDetailPriceElement() {
  return document.querySelector('[data-product-detail-price]');
}
function setElementValue(selector, value) {
  var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var useTextContent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var searchContext = parent || document;
  var element = searchContext.querySelector(selector);
  if (element) {
    if (useTextContent) {
      element.textContent = value;
    } else {
      element.innerHTML = value;
    }
  }
}
function toggleHiddenClass(element, hide) {
  if (!element) return;
  if (hide) {
    element.classList.add('!hidden');
  } else {
    element.classList.remove('!hidden');
  }
}
function updateProductDetailPrice(_ref) {
  var currentPrice = _ref.currentPrice,
    wasPrice = _ref.wasPrice,
    discountPercentage = _ref.discountPercentage,
    savingsAmount = _ref.savingsAmount,
    sellingPlanId = _ref.sellingPlanId;
  var priceElement = getProductDetailPriceElement();
  if (!priceElement || typeof Shopify === 'undefined' || typeof Shopify.formatMoney !== 'function') {
    return;
  }
  setElementValue('[data-cart-price-value]', Shopify.formatMoney(currentPrice), priceElement);
  if (wasPrice !== undefined) {
    var wasPriceFormatted = Shopify.formatMoney(wasPrice).trim();
    var currentPriceFormatted = Shopify.formatMoney(currentPrice).trim();
    var wasPriceValue = wasPriceFormatted !== currentPriceFormatted ? Shopify.formatMoney(wasPrice) : '';
    setElementValue('[data-cart-price-was-value]', wasPriceValue, priceElement);
  }
  var discountElement = priceElement.querySelector('[data-cart-discount-element]');
  var hasDiscount = savingsAmount > 0 && discountPercentage !== undefined;
  toggleHiddenClass(discountElement, !hasDiscount);
  if (hasDiscount && discountElement) {
    setElementValue('[data-cart-discount-percent-value]', discountPercentage, discountElement, true);
    setElementValue('[data-cart-discount-value]', Shopify.formatMoney(savingsAmount), discountElement);
  }
  if (sellingPlanId !== undefined) {
    var sellingPlanInput = document.querySelector('[data-selling-plan-input-id]');
    if (sellingPlanInput) {
      sellingPlanInput.value = sellingPlanId;
    }
  }
}
function resetProductDetailPrice(originalPrices) {
  var priceElement = getProductDetailPriceElement();
  if (!priceElement || !originalPrices) return;
  if (originalPrices.currentPrice) {
    setElementValue('[data-cart-price-value]', originalPrices.currentPrice, priceElement);
  }
  var shouldShowWasPrice = originalPrices.wasPriceText && originalPrices.currentPriceText && originalPrices.wasPriceText !== originalPrices.currentPriceText;
  var wasPriceValue = shouldShowWasPrice ? originalPrices.wasPrice : '';
  setElementValue('[data-cart-price-was-value]', wasPriceValue, priceElement);
  var discountElement = priceElement.querySelector('[data-cart-discount-element]');
  if (discountElement) {
    toggleHiddenClass(discountElement, originalPrices.discountElementHidden);
    if (originalPrices.discountPercent) {
      setElementValue('[data-cart-discount-percent-value]', originalPrices.discountPercent, discountElement, true);
    }
    if (originalPrices.discountValue) {
      setElementValue('[data-cart-discount-value]', originalPrices.discountValue, discountElement);
    }
  }
  var sellingPlanInput = document.querySelector('[data-selling-plan-input-id]');
  if (sellingPlanInput) {
    sellingPlanInput.value = '';
  }
}
function calculateSubscriptionDiscount(basePrice, selectedPlan) {
  var discountedPrice = basePrice;
  var discountPercentage = 0;
  if (selectedPlan.price_adjustments && selectedPlan.price_adjustments.length > 0) {
    var adjustment = selectedPlan.price_adjustments[0];
    if (adjustment.value_type === 'percentage') {
      discountPercentage = parseFloat(adjustment.value);
      discountedPrice = basePrice * (1 - discountPercentage / 100);
    } else if (adjustment.value_type === 'fixed_amount') {
      var discountAmount = parseFloat(adjustment.value);
      discountedPrice = basePrice - discountAmount;
      discountPercentage = discountAmount / basePrice * 100;
    } else if (adjustment.value_type === 'price') {
      discountedPrice = parseFloat(adjustment.value);
      discountPercentage = (basePrice - discountedPrice) / basePrice * 100;
    }
  }
  return {
    discountedPrice: Math.round(discountedPrice),
    discountPercentage: Math.round(discountPercentage)
  };
}
function updateSubscriptionPriceBox(priceElements, basePrice, discountedPrice, discountPercentage) {
  if (typeof Shopify === 'undefined' || typeof Shopify.formatMoney !== 'function') return;
  if (priceElements.old) {
    priceElements.old.innerHTML = Shopify.formatMoney(basePrice);
  }
  if (priceElements.discounted) {
    var supElement = priceElements.discounted.querySelector('sup');
    var formattedPrice = Shopify.formatMoney(discountedPrice);
    if (supElement) {
      priceElements.discounted.innerHTML = formattedPrice;
      priceElements.discounted.appendChild(supElement);
    } else {
      priceElements.discounted.innerHTML = formattedPrice;
    }
  }
  if (priceElements.discountPercentage) {
    priceElements.discountPercentage.textContent = "-".concat(discountPercentage, "%");
  }
}
function updateSubscriptionPrice(basePrice, selectedPlan, priceElements) {
  if (!selectedPlan) return;
  var _calculateSubscriptio = calculateSubscriptionDiscount(basePrice, selectedPlan),
    discountedPrice = _calculateSubscriptio.discountedPrice,
    discountPercentage = _calculateSubscriptio.discountPercentage;
  var savingsAmount = basePrice - discountedPrice;
  var quantityInput = document.querySelector('[data-cart-quantity-input]');
  var quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
  updateSubscriptionPriceBox(priceElements, basePrice, discountedPrice, discountPercentage);
  if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
    updateProductDetailPrice({
      currentPrice: discountedPrice * quantity,
      wasPrice: basePrice * quantity,
      discountPercentage: discountPercentage,
      savingsAmount: savingsAmount * quantity,
      sellingPlanId: selectedPlan.id
    });
  }
}
function updateSellingPlanInput(sellingPlanId) {
  var sellingPlanInput = document.querySelector('[data-selling-plan-input-id]');
  if (sellingPlanInput) {
    sellingPlanInput.value = sellingPlanId;
  }
}
function isSubscriptionActive() {
  var purchaseWidget = document.querySelector('sga-purchase-widget');
  if (!purchaseWidget) return false;
  return purchaseWidget.getAttribute('data-active-variant') === 'subscription';
}
function getSubscriptionPricing(quantity) {
  var subscriptionWidget = document.querySelector('sga-purchase-widget-variant-subscription');
  if (!subscriptionWidget) return null;
  var sellingPlansDataElement = subscriptionWidget.querySelector('[data-selling-plans-data]');
  var nativeSelect = subscriptionWidget.querySelector('select[name="selling-plan"]');
  if (!sellingPlansDataElement || !nativeSelect) return null;
  var sellingPlansData;
  try {
    sellingPlansData = JSON.parse(sellingPlansDataElement.textContent);
  } catch (e) {
    console.error('Failed to parse selling plans data:', e);
    return null;
  }
  var basePrice = parseFloat(subscriptionWidget.dataset.productPrice);
  var selectedPlanId = parseInt(nativeSelect.value);
  if (!selectedPlanId || !basePrice) return null;
  var selectedPlan = sellingPlansData.plans.find(function (plan) {
    return plan.id === selectedPlanId;
  });
  if (!selectedPlan) return null;
  var _calculateSubscriptio2 = calculateSubscriptionDiscount(basePrice, selectedPlan),
    discountedPrice = _calculateSubscriptio2.discountedPrice,
    discountPercentage = _calculateSubscriptio2.discountPercentage;
  var totalPrice = discountedPrice * Number(quantity);
  var regularPrice = basePrice * Number(quantity);
  var savingsAmount = regularPrice - totalPrice;
  return {
    totalPrice: totalPrice,
    regularPrice: regularPrice,
    savingsAmount: savingsAmount,
    discountPercentage: discountPercentage,
    pricePerUnit: discountedPrice,
    sellingPlanId: selectedPlanId
  };
}
window.globals = window.globals || {};
window.globals.isSubscriptionActive = isSubscriptionActive;
window.globals.getSubscriptionPricing = getSubscriptionPricing;
;// ./js/partials/_purchase-widget-frequency-list.js
function _purchase_widget_frequency_list_typeof(o) { "@babel/helpers - typeof"; return _purchase_widget_frequency_list_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _purchase_widget_frequency_list_typeof(o); }
function _purchase_widget_frequency_list_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _purchase_widget_frequency_list_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _purchase_widget_frequency_list_toPropertyKey(o.key), o); } }
function _purchase_widget_frequency_list_createClass(e, r, t) { return r && _purchase_widget_frequency_list_defineProperties(e.prototype, r), t && _purchase_widget_frequency_list_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _purchase_widget_frequency_list_toPropertyKey(t) { var i = _purchase_widget_frequency_list_toPrimitive(t, "string"); return "symbol" == _purchase_widget_frequency_list_typeof(i) ? i : i + ""; }
function _purchase_widget_frequency_list_toPrimitive(t, r) { if ("object" != _purchase_widget_frequency_list_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _purchase_widget_frequency_list_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _purchase_widget_frequency_list_callSuper(t, o, e) { return o = _purchase_widget_frequency_list_getPrototypeOf(o), _purchase_widget_frequency_list_possibleConstructorReturn(t, _purchase_widget_frequency_list_isNativeReflectConstruct() ? Reflect.construct(o, e || [], _purchase_widget_frequency_list_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _purchase_widget_frequency_list_possibleConstructorReturn(t, e) { if (e && ("object" == _purchase_widget_frequency_list_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _purchase_widget_frequency_list_assertThisInitialized(t); }
function _purchase_widget_frequency_list_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _purchase_widget_frequency_list_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _purchase_widget_frequency_list_setPrototypeOf(t, e); }
function _purchase_widget_frequency_list_wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _purchase_widget_frequency_list_wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_purchase_widget_frequency_list_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _purchase_widget_frequency_list_construct(t, arguments, _purchase_widget_frequency_list_getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _purchase_widget_frequency_list_setPrototypeOf(Wrapper, t); }, _purchase_widget_frequency_list_wrapNativeSuper(t); }
function _purchase_widget_frequency_list_construct(t, e, r) { if (_purchase_widget_frequency_list_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _purchase_widget_frequency_list_setPrototypeOf(p, r.prototype), p; }
function _purchase_widget_frequency_list_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_purchase_widget_frequency_list_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _purchase_widget_frequency_list_isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _purchase_widget_frequency_list_setPrototypeOf(t, e) { return _purchase_widget_frequency_list_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _purchase_widget_frequency_list_setPrototypeOf(t, e); }
function _purchase_widget_frequency_list_getPrototypeOf(t) { return _purchase_widget_frequency_list_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _purchase_widget_frequency_list_getPrototypeOf(t); }


if (!customElements.get('sga-purchase-widget-frequency-list')) {
  var _SgaPurchaseWidgetFrequencyList = function (_HTMLElement) {
    function _SgaPurchaseWidgetFrequencyList() {
      _purchase_widget_frequency_list_classCallCheck(this, _SgaPurchaseWidgetFrequencyList);
      return _purchase_widget_frequency_list_callSuper(this, _SgaPurchaseWidgetFrequencyList, arguments);
    }
    _purchase_widget_frequency_list_inherits(_SgaPurchaseWidgetFrequencyList, _HTMLElement);
    return _purchase_widget_frequency_list_createClass(_SgaPurchaseWidgetFrequencyList, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this = this;
        this.init();
        waitForIntelligems(function () {
          _this.updateIntelligemsPrice();
        });
      }
    }, {
      key: "init",
      value: function init() {
        var _this2 = this;
        var priceContainer = document.querySelector('[data-subscription-price]');
        var sellingPlansDataElement = this.querySelector('[data-selling-plans-data]');
        if (!priceContainer || !sellingPlansDataElement) return;
        this.priceElements = {
          old: priceContainer.querySelector('[data-subscription-price-old]'),
          discounted: priceContainer.querySelector('[data-subscription-price-discounted]'),
          discountPercentage: priceContainer.querySelector('[data-subscription-price-discount-percentage]')
        };
        try {
          this.sellingPlansData = JSON.parse(sellingPlansDataElement.textContent);
        } catch (e) {
          console.error('Failed to parse selling plans data:', e);
          return;
        }
        this.productId = this.dataset.productId;
        this.basePrice = parseFloat(this.dataset.productPrice);
        this.frequencyItems = this.querySelectorAll('[data-frequency-item]');
        if (!this.frequencyItems.length) return;
        this.frequencyItems.forEach(function (item) {
          item.addEventListener('click', function (e) {
            return _this2.handleFrequencyClick(e);
          });
        });
        this.purchaseWidget = this.closest('sga-purchase-widget');
        if (this.purchaseWidget) {
          if (!this.boundVariantChangeHandler) {
            this.boundVariantChangeHandler = function (e) {
              if (e.detail.variantType === 'subscription') {
                _this2.updateActiveFrequencyItem();
              }
            };
          }
          this.purchaseWidget.addEventListener('purchase-widget-variant-changed', this.boundVariantChangeHandler);
        }
      }
    }, {
      key: "updateActiveFrequencyItem",
      value: function updateActiveFrequencyItem() {
        var activeItem = this.querySelector('[data-frequency-item].active');
        if (activeItem) {
          var planId = parseInt(activeItem.dataset.sellingPlanId);
          updateSellingPlanInput(planId);
          this.updatePrice(planId);
          this.dispatchFrequencyChangeEvent(planId);
        }
      }
    }, {
      key: "dispatchFrequencyChangeEvent",
      value: function dispatchFrequencyChangeEvent(planId) {
        var selectedPlan = this.sellingPlansData.plans.find(function (plan) {
          return plan.id === planId;
        });
        if (selectedPlan) {
          var _calculateSubscriptio = calculateSubscriptionDiscount(this.basePrice, selectedPlan),
            discountPercentage = _calculateSubscriptio.discountPercentage;
          this.dispatchEvent(new CustomEvent('frequency-changed', {
            detail: {
              discountPercentage: discountPercentage
            },
            bubbles: true
          }));
        }
      }
    }, {
      key: "handleFrequencyClick",
      value: function handleFrequencyClick(event) {
        var clickedItem = event.currentTarget;
        this.frequencyItems.forEach(function (item) {
          item.classList.remove('active');
        });
        clickedItem.classList.add('active');
        var sellingPlanId = parseInt(clickedItem.dataset.sellingPlanId);
        updateSellingPlanInput(sellingPlanId);
        if (isSubscriptionActive()) {
          this.updatePrice(sellingPlanId);
        }
        this.dispatchFrequencyChangeEvent(sellingPlanId);
      }
    }, {
      key: "updatePrice",
      value: function updatePrice(planId) {
        var selectedPlan = this.sellingPlansData.plans.find(function (plan) {
          return plan.id === planId;
        });
        if (!selectedPlan) return;
        updateSubscriptionPrice(this.basePrice, selectedPlan, this.priceElements);
        if (window.globals && window.globals.updateQuickFacts) {
          var _calculateSubscriptio2 = calculateSubscriptionDiscount(this.basePrice, selectedPlan),
            discountedPrice = _calculateSubscriptio2.discountedPrice;
          var quantityInput = document.querySelector('[data-cart-quantity-input]');
          var quantity = quantityInput ? parseInt(quantityInput.value) : 1;
          window.globals.updateQuickFacts(quantity, {
            price_per_unit_raw: discountedPrice
          });
        }
      }
    }, {
      key: "updateIntelligemsPrice",
      value: function updateIntelligemsPrice() {
        if (!this.productId) return;
        var intelliGemsPrice = getIntelligemsPrice(this.productId);
        if (!intelliGemsPrice) return;
        this.basePrice = intelliGemsPrice;
        if (isSubscriptionActive()) {
          this.updateActiveFrequencyItem();
        }
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        if (this.purchaseWidget && this.boundVariantChangeHandler) {
          this.purchaseWidget.removeEventListener('purchase-widget-variant-changed', this.boundVariantChangeHandler);
        }
      }
    }]);
  }(_purchase_widget_frequency_list_wrapNativeSuper(HTMLElement));
  customElements.define('sga-purchase-widget-frequency-list', _SgaPurchaseWidgetFrequencyList);
}
/* harmony default export */ var _purchase_widget_frequency_list = ((/* unused pure expression or super */ null && (SgaPurchaseWidgetFrequencyList)));
;// ./js/partials/_purchase-widget-variant-subscription.js
function _purchase_widget_variant_subscription_typeof(o) { "@babel/helpers - typeof"; return _purchase_widget_variant_subscription_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _purchase_widget_variant_subscription_typeof(o); }
function _purchase_widget_variant_subscription_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _purchase_widget_variant_subscription_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _purchase_widget_variant_subscription_toPropertyKey(o.key), o); } }
function _purchase_widget_variant_subscription_createClass(e, r, t) { return r && _purchase_widget_variant_subscription_defineProperties(e.prototype, r), t && _purchase_widget_variant_subscription_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _purchase_widget_variant_subscription_toPropertyKey(t) { var i = _purchase_widget_variant_subscription_toPrimitive(t, "string"); return "symbol" == _purchase_widget_variant_subscription_typeof(i) ? i : i + ""; }
function _purchase_widget_variant_subscription_toPrimitive(t, r) { if ("object" != _purchase_widget_variant_subscription_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _purchase_widget_variant_subscription_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _purchase_widget_variant_subscription_callSuper(t, o, e) { return o = _purchase_widget_variant_subscription_getPrototypeOf(o), _purchase_widget_variant_subscription_possibleConstructorReturn(t, _purchase_widget_variant_subscription_isNativeReflectConstruct() ? Reflect.construct(o, e || [], _purchase_widget_variant_subscription_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _purchase_widget_variant_subscription_possibleConstructorReturn(t, e) { if (e && ("object" == _purchase_widget_variant_subscription_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _purchase_widget_variant_subscription_assertThisInitialized(t); }
function _purchase_widget_variant_subscription_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _purchase_widget_variant_subscription_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _purchase_widget_variant_subscription_setPrototypeOf(t, e); }
function _purchase_widget_variant_subscription_wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _purchase_widget_variant_subscription_wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_purchase_widget_variant_subscription_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _purchase_widget_variant_subscription_construct(t, arguments, _purchase_widget_variant_subscription_getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _purchase_widget_variant_subscription_setPrototypeOf(Wrapper, t); }, _purchase_widget_variant_subscription_wrapNativeSuper(t); }
function _purchase_widget_variant_subscription_construct(t, e, r) { if (_purchase_widget_variant_subscription_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _purchase_widget_variant_subscription_setPrototypeOf(p, r.prototype), p; }
function _purchase_widget_variant_subscription_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_purchase_widget_variant_subscription_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _purchase_widget_variant_subscription_isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _purchase_widget_variant_subscription_setPrototypeOf(t, e) { return _purchase_widget_variant_subscription_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _purchase_widget_variant_subscription_setPrototypeOf(t, e); }
function _purchase_widget_variant_subscription_getPrototypeOf(t) { return _purchase_widget_variant_subscription_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _purchase_widget_variant_subscription_getPrototypeOf(t); }


if (!customElements.get('sga-purchase-widget-variant-subscription')) {
  var SgaPurchaseWidgetVariantSubscription = function (_HTMLElement) {
    function SgaPurchaseWidgetVariantSubscription() {
      _purchase_widget_variant_subscription_classCallCheck(this, SgaPurchaseWidgetVariantSubscription);
      return _purchase_widget_variant_subscription_callSuper(this, SgaPurchaseWidgetVariantSubscription, arguments);
    }
    _purchase_widget_variant_subscription_inherits(SgaPurchaseWidgetVariantSubscription, _HTMLElement);
    return _purchase_widget_variant_subscription_createClass(SgaPurchaseWidgetVariantSubscription, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this = this;
        this.init();
        waitForIntelligems(function () {
          _this.updateIntelligemsPrice();
        });
      }
    }, {
      key: "init",
      value: function init() {
        var _this2 = this;
        var priceContainer = this.querySelector('[data-subscription-price]');
        var sellingPlansDataElement = this.querySelector('[data-selling-plans-data]');
        var nativeSelect = this.querySelector('select[name="selling-plan"]');
        if (!priceContainer || !sellingPlansDataElement || !nativeSelect) return;
        this.priceElements = {
          old: priceContainer.querySelector('[data-subscription-price-old]'),
          discounted: priceContainer.querySelector('[data-subscription-price-discounted]'),
          discountPercentage: priceContainer.querySelector('[data-subscription-price-discount-percentage]')
        };
        this.purchaseWidget = this.closest('sga-purchase-widget');
        try {
          this.sellingPlansData = JSON.parse(sellingPlansDataElement.textContent);
        } catch (e) {
          console.error('Failed to parse selling plans data:', e);
          return;
        }
        this.productId = this.dataset.productId;
        this.basePrice = parseFloat(this.dataset.productPrice);
        this.nativeSelect = nativeSelect;
        nativeSelect.addEventListener('change', function (e) {
          var selectedPlanId = parseInt(e.target.value);
          if (isSubscriptionActive()) {
            _this2.updatePrice(selectedPlanId);
          }
        });
        if (this.purchaseWidget) {
          this.purchaseWidget.addEventListener('purchase-widget-variant-changed', function (e) {
            if (e.detail.variantType === 'subscription') {
              _this2.updateSelectedPlanPrice();
            }
          });
        }
        this.updateSelectedPlanPrice();
      }
    }, {
      key: "updateSelectedPlanPrice",
      value: function updateSelectedPlanPrice() {
        if (!isSubscriptionActive()) return;
        var selectedPlanId = parseInt(this.nativeSelect.value);
        if (selectedPlanId) {
          this.updatePrice(selectedPlanId);
        }
      }
    }, {
      key: "updatePrice",
      value: function updatePrice(planId) {
        var selectedPlan = this.sellingPlansData.plans.find(function (plan) {
          return plan.id === planId;
        });
        if (!selectedPlan) return;
        updateSubscriptionPrice(this.basePrice, selectedPlan, this.priceElements);
        if (window.globals && window.globals.updateQuickFacts) {
          var _calculateSubscriptio = calculateSubscriptionDiscount(this.basePrice, selectedPlan),
            discountedPrice = _calculateSubscriptio.discountedPrice;
          var quantityInput = document.querySelector('[data-cart-quantity-input]');
          var quantity = quantityInput ? parseInt(quantityInput.value) : 1;
          window.globals.updateQuickFacts(quantity, {
            price_per_unit_raw: discountedPrice
          });
        }
      }
    }, {
      key: "updateIntelligemsPrice",
      value: function updateIntelligemsPrice() {
        if (!this.productId) return;
        var intelliGemsPrice = getIntelligemsPrice(this.productId);
        if (!intelliGemsPrice) return;
        this.basePrice = intelliGemsPrice;
        this.updateSelectedPlanPrice();
      }
    }]);
  }(_purchase_widget_variant_subscription_wrapNativeSuper(HTMLElement));
  customElements.define('sga-purchase-widget-variant-subscription', SgaPurchaseWidgetVariantSubscription);
}
;// ./js/partials/_purchase-widget-packages.js
function _purchase_widget_packages_typeof(o) { "@babel/helpers - typeof"; return _purchase_widget_packages_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _purchase_widget_packages_typeof(o); }
function _purchase_widget_packages_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _purchase_widget_packages_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _purchase_widget_packages_toPropertyKey(o.key), o); } }
function _purchase_widget_packages_createClass(e, r, t) { return r && _purchase_widget_packages_defineProperties(e.prototype, r), t && _purchase_widget_packages_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _purchase_widget_packages_toPropertyKey(t) { var i = _purchase_widget_packages_toPrimitive(t, "string"); return "symbol" == _purchase_widget_packages_typeof(i) ? i : i + ""; }
function _purchase_widget_packages_toPrimitive(t, r) { if ("object" != _purchase_widget_packages_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _purchase_widget_packages_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _purchase_widget_packages_callSuper(t, o, e) { return o = _purchase_widget_packages_getPrototypeOf(o), _purchase_widget_packages_possibleConstructorReturn(t, _purchase_widget_packages_isNativeReflectConstruct() ? Reflect.construct(o, e || [], _purchase_widget_packages_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _purchase_widget_packages_possibleConstructorReturn(t, e) { if (e && ("object" == _purchase_widget_packages_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _purchase_widget_packages_assertThisInitialized(t); }
function _purchase_widget_packages_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _purchase_widget_packages_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _purchase_widget_packages_setPrototypeOf(t, e); }
function _purchase_widget_packages_wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _purchase_widget_packages_wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_purchase_widget_packages_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _purchase_widget_packages_construct(t, arguments, _purchase_widget_packages_getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _purchase_widget_packages_setPrototypeOf(Wrapper, t); }, _purchase_widget_packages_wrapNativeSuper(t); }
function _purchase_widget_packages_construct(t, e, r) { if (_purchase_widget_packages_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _purchase_widget_packages_setPrototypeOf(p, r.prototype), p; }
function _purchase_widget_packages_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_purchase_widget_packages_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _purchase_widget_packages_isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _purchase_widget_packages_setPrototypeOf(t, e) { return _purchase_widget_packages_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _purchase_widget_packages_setPrototypeOf(t, e); }
function _purchase_widget_packages_getPrototypeOf(t) { return _purchase_widget_packages_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _purchase_widget_packages_getPrototypeOf(t); }


if (!customElements.get('sga-purchase-widget-packages')) {
  var _SgaPurchaseWidgetPackages = function (_HTMLElement) {
    function _SgaPurchaseWidgetPackages() {
      var _this;
      _purchase_widget_packages_classCallCheck(this, _SgaPurchaseWidgetPackages);
      _this = _purchase_widget_packages_callSuper(this, _SgaPurchaseWidgetPackages);
      _this.handleSelectedClick = _this.handleSelectedClick.bind(_this);
      _this.handleOptionsClick = _this.handleOptionsClick.bind(_this);
      _this.handleOutsideClick = _this.handleOutsideClick.bind(_this);
      _this.handleFrequencyChange = _this.handleFrequencyChange.bind(_this);
      _this.abortController = new AbortController();
      _this._initialized = false;
      return _this;
    }
    _purchase_widget_packages_inherits(_SgaPurchaseWidgetPackages, _HTMLElement);
    return _purchase_widget_packages_createClass(_SgaPurchaseWidgetPackages, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this2 = this;
        this.init();
        waitForIntelligems(function () {
          _this2.updateIntelligemsPrice();
        });
      }
    }, {
      key: "init",
      value: function init() {
        if (this._initialized) return;
        this.dropdown = this.querySelector('[data-quantity-dropdown]');
        this.selectedElement = this.querySelector('[data-quantity-selected]');
        this.optionsList = this.querySelector('[data-quantity-options]');
        this.options = this.querySelectorAll('[data-quantity-option]');
        if (!this.dropdown || !this.selectedElement || !this.optionsList || !this.options.length) return;
        this.isOpen = false;
        this.productId = this.dropdown.dataset.productId;
        this.basePrice = parseFloat(this.dropdown.dataset.productPrice);
        this.dosesPerPackage = parseFloat(this.dropdown.dataset.dosesPerPackage);
        this.currentDiscountPercentage = parseFloat(this.dropdown.dataset.discountPercentage) || 0;
        var signal = this.abortController.signal;
        this.selectedElement.addEventListener('click', this.handleSelectedClick, {
          signal: signal
        });
        this.addEventListener('click', this.handleOptionsClick, {
          signal: signal
        });
        document.addEventListener('click', this.handleOutsideClick, {
          signal: signal
        });
        document.addEventListener('frequency-changed', this.handleFrequencyChange, {
          signal: signal
        });
        this._initialized = true;
      }
    }, {
      key: "handleSelectedClick",
      value: function handleSelectedClick(event) {
        this.toggleDropdown(event);
      }
    }, {
      key: "handleOptionsClick",
      value: function handleOptionsClick(event) {
        var option = event.target.closest('[data-quantity-option]');
        if (option && this.contains(option)) {
          this.handleOptionClick(event, option);
        }
      }
    }, {
      key: "toggleDropdown",
      value: function toggleDropdown(event) {
        event.stopPropagation();
        if (this.isOpen) {
          this.closeDropdown();
        } else {
          this.openDropdown();
        }
      }
    }, {
      key: "openDropdown",
      value: function openDropdown() {
        this.isOpen = true;
        this.optionsList.classList.add('sga-subscription-widget__quantity-dropdown__options--active');
      }
    }, {
      key: "closeDropdown",
      value: function closeDropdown() {
        this.isOpen = false;
        this.optionsList.classList.remove('sga-subscription-widget__quantity-dropdown__options--active');
      }
    }, {
      key: "handleOptionClick",
      value: function handleOptionClick(event, clickedOption) {
        var allOptions = this.querySelectorAll('[data-quantity-option]');
        allOptions.forEach(function (opt) {
          opt.classList.remove('sga-subscription-widget__quantity-dropdown__option--active');
          var radio = opt.querySelector('input[type="radio"]');
          if (radio) radio.checked = false;
        });
        clickedOption.classList.add('sga-subscription-widget__quantity-dropdown__option--active');
        var clickedRadio = clickedOption.querySelector('input[type="radio"]');
        if (clickedRadio) clickedRadio.checked = true;
        this.updateSelectedDisplay(clickedOption);
        var quantity = parseInt(clickedOption.dataset.quantity);
        this.updateQuantityInput(quantity);
        this.updateProductPrice(quantity, this.currentDiscountPercentage);
        this.closeDropdown();
      }
    }, {
      key: "updateSelectedDisplay",
      value: function updateSelectedDisplay(option) {
        var optionMainText = option.querySelector('[data-quantity-main-text]');
        var optionSubText = option.querySelector('[data-quantity-sub-text]');
        var optionPrice = option.querySelector('[data-quantity-price]');
        var optionSavings = option.querySelector('[data-quantity-savings-value]');
        var optionDiscountBadge = option.querySelector('[data-quantity-discount-badge]');
        var selectedMainText = this.selectedElement.querySelector('[data-quantity-main-text]');
        var selectedSubText = this.selectedElement.querySelector('[data-quantity-sub-text]');
        var selectedPrice = this.selectedElement.querySelector('[data-quantity-price]');
        var selectedSavings = this.selectedElement.querySelector('[data-quantity-savings-value]');
        var selectedDiscountBadge = this.selectedElement.querySelector('[data-quantity-discount-badge]');
        if (selectedMainText && optionMainText) {
          selectedMainText.textContent = optionMainText.textContent;
        }
        if (selectedSubText && optionSubText) {
          selectedSubText.textContent = optionSubText.textContent;
        }
        if (selectedPrice && optionPrice) {
          selectedPrice.textContent = optionPrice.textContent;
        }
        if (selectedSavings && optionSavings) {
          selectedSavings.textContent = optionSavings.textContent;
        }
        if (selectedDiscountBadge && optionDiscountBadge) {
          selectedDiscountBadge.textContent = optionDiscountBadge.textContent;
        }
      }
    }, {
      key: "updateQuantityInput",
      value: function updateQuantityInput(quantity) {
        var quantityInput = document.querySelector('[data-cart-quantity-input]');
        if (quantityInput) {
          quantityInput.value = quantity;
        }
        if (window.globals && window.globals.updateQuickFacts) {
          var discountMultiplier = (100 - this.currentDiscountPercentage) / 100;
          var pricePerUnitRaw = this.basePrice * discountMultiplier;
          window.globals.updateQuickFacts(quantity, {
            price_per_unit_raw: pricePerUnitRaw
          });
        }
      }
    }, {
      key: "updateProductPrice",
      value: function updateProductPrice(quantity, discountPercentage) {
        if (!quantity || typeof Shopify === 'undefined' || typeof Shopify.formatMoney !== 'function') return;
        var discountMultiplier = (100 - discountPercentage) / 100;
        var discountedUnitPrice = this.basePrice * discountMultiplier;
        var discountedTotalPrice = discountedUnitPrice * quantity;
        var regularTotalPrice = this.basePrice * quantity;
        var savingsAmount = regularTotalPrice - discountedTotalPrice;
        updateProductDetailPrice({
          currentPrice: discountedTotalPrice,
          wasPrice: regularTotalPrice,
          discountPercentage: discountPercentage,
          savingsAmount: savingsAmount
        });
      }
    }, {
      key: "recalculateOptionsPrices",
      value: function recalculateOptionsPrices() {
        var _this3 = this;
        var updateDiscountBadge = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var allOptions = this.querySelectorAll('[data-quantity-option]');
        allOptions.forEach(function (option) {
          var quantity = parseInt(option.dataset.quantity);
          var discountMultiplier = (100 - _this3.currentDiscountPercentage) / 100;
          var discountedUnitPrice = _this3.basePrice * discountMultiplier;
          var discountedTotalPrice = discountedUnitPrice * quantity;
          var savingsAmount = _this3.basePrice * quantity - discountedTotalPrice;
          var priceElement = option.querySelector('[data-quantity-price]');
          var savingsElement = option.querySelector('[data-quantity-savings-value]');
          if (priceElement && typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
            priceElement.textContent = Shopify.formatMoney(discountedTotalPrice);
          }
          if (savingsElement && typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
            savingsElement.textContent = Shopify.formatMoney(savingsAmount);
          }
          if (updateDiscountBadge) {
            var discountBadge = option.querySelector('[data-quantity-discount-badge]');
            if (discountBadge) {
              discountBadge.textContent = "".concat(_this3.currentDiscountPercentage, "%");
            }
          }
        });
        if (updateDiscountBadge && this.dropdown) {
          this.dropdown.dataset.discountPercentage = this.currentDiscountPercentage;
        }
      }
    }, {
      key: "updateActiveOptionDisplay",
      value: function updateActiveOptionDisplay() {
        var activeOption = this.querySelector('[data-quantity-option].sga-subscription-widget__quantity-dropdown__option--active');
        if (activeOption) {
          this.updateSelectedDisplay(activeOption);
          var quantity = parseInt(activeOption.dataset.quantity);
          this.updateProductPrice(quantity, this.currentDiscountPercentage);
        }
      }
    }, {
      key: "handleFrequencyChange",
      value: function handleFrequencyChange(event) {
        var discountPercentage = event.detail.discountPercentage;
        this.currentDiscountPercentage = discountPercentage;
        this.recalculateOptionsPrices(true);
        this.updateActiveOptionDisplay();
      }
    }, {
      key: "handleOutsideClick",
      value: function handleOutsideClick(event) {
        if (!this.contains(event.target) && this.isOpen) {
          this.closeDropdown();
        }
      }
    }, {
      key: "updateIntelligemsPrice",
      value: function updateIntelligemsPrice() {
        if (!this.productId) return;
        var intelliGemsPrice = getIntelligemsPrice(this.productId);
        if (!intelliGemsPrice) return;
        this.basePrice = intelliGemsPrice;
        this.recalculateOptionsPrices();
        this.updateActiveOptionDisplay();
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        this.abortController.abort();
        this.abortController = new AbortController();
        this._initialized = false;
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this.disconnectedCallback();
      }
    }]);
  }(_purchase_widget_packages_wrapNativeSuper(HTMLElement));
  customElements.define('sga-purchase-widget-packages', _SgaPurchaseWidgetPackages);
}
/* harmony default export */ var _purchase_widget_packages = ((/* unused pure expression or super */ null && (SgaPurchaseWidgetPackages)));
;// ./js/partials/_purchase-widget.js
function _purchase_widget_typeof(o) { "@babel/helpers - typeof"; return _purchase_widget_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _purchase_widget_typeof(o); }
function _purchase_widget_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _purchase_widget_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _purchase_widget_toPropertyKey(o.key), o); } }
function _purchase_widget_createClass(e, r, t) { return r && _purchase_widget_defineProperties(e.prototype, r), t && _purchase_widget_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _purchase_widget_toPropertyKey(t) { var i = _purchase_widget_toPrimitive(t, "string"); return "symbol" == _purchase_widget_typeof(i) ? i : i + ""; }
function _purchase_widget_toPrimitive(t, r) { if ("object" != _purchase_widget_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _purchase_widget_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _purchase_widget_callSuper(t, o, e) { return o = _purchase_widget_getPrototypeOf(o), _purchase_widget_possibleConstructorReturn(t, _purchase_widget_isNativeReflectConstruct() ? Reflect.construct(o, e || [], _purchase_widget_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _purchase_widget_possibleConstructorReturn(t, e) { if (e && ("object" == _purchase_widget_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _purchase_widget_assertThisInitialized(t); }
function _purchase_widget_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _purchase_widget_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _purchase_widget_setPrototypeOf(t, e); }
function _purchase_widget_wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _purchase_widget_wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_purchase_widget_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _purchase_widget_construct(t, arguments, _purchase_widget_getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _purchase_widget_setPrototypeOf(Wrapper, t); }, _purchase_widget_wrapNativeSuper(t); }
function _purchase_widget_construct(t, e, r) { if (_purchase_widget_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _purchase_widget_setPrototypeOf(p, r.prototype), p; }
function _purchase_widget_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_purchase_widget_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _purchase_widget_isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _purchase_widget_setPrototypeOf(t, e) { return _purchase_widget_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _purchase_widget_setPrototypeOf(t, e); }
function _purchase_widget_getPrototypeOf(t) { return _purchase_widget_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _purchase_widget_getPrototypeOf(t); }


if (!customElements.get('sga-purchase-widget')) {
  var SgaPurchaseWidget = function (_HTMLElement) {
    function SgaPurchaseWidget() {
      _purchase_widget_classCallCheck(this, SgaPurchaseWidget);
      return _purchase_widget_callSuper(this, SgaPurchaseWidget, arguments);
    }
    _purchase_widget_inherits(SgaPurchaseWidget, _HTMLElement);
    return _purchase_widget_createClass(SgaPurchaseWidget, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this = this;
        this.init();
        waitForIntelligems(function () {
          _this.updateIntelligemsPrice();
        });
      }
    }, {
      key: "init",
      value: function init() {
        var _this2 = this;
        this.variantItems = this.querySelectorAll('[data-variants-item]');
        if (!this.variantItems.length) return;
        this.subscriptionLayout = this.dataset.subscriptionLayout;
        this.mainProductSubscriptionAvailabilityContainer = document.querySelector('[data-product-detail-subscription-availability]');
        this.mainProductOneTimeAvailabilityContainer = document.querySelector('[data-product-detail-one-time-availability]');
        var originalPricesElement = this.querySelector('[data-original-prices]');
        if (originalPricesElement) {
          try {
            this.originalPrices = JSON.parse(originalPricesElement.textContent);
          } catch (e) {
            console.error('Failed to parse original prices:', e);
          }
        }
        var subscriptionVariant = this.querySelector('[data-product-id]');
        if (subscriptionVariant) {
          this.productId = subscriptionVariant.dataset.productId;
        }
        this.variantItems.forEach(function (item) {
          item.addEventListener('click', function (e) {
            return _this2.handleVariantClick(e);
          });
        });
      }
    }, {
      key: "resetToOriginalPrices",
      value: function resetToOriginalPrices() {
        resetProductDetailPrice(this.originalPrices);
      }
    }, {
      key: "toggleQuantityInputVisibility",
      value: function toggleQuantityInputVisibility(variantType) {
        if (this.subscriptionLayout !== 'detailed') return;
        var quantityInput = document.querySelector('quantity-input');
        if (!quantityInput) return;
        if (variantType === 'subscription') {
          quantityInput.classList.add('!hidden');
        } else {
          quantityInput.classList.remove('!hidden');
        }
      }
    }, {
      key: "resetQuantityInput",
      value: function resetQuantityInput() {
        var quantityInput = document.querySelector('[data-cart-quantity-input]');
        if (quantityInput) {
          quantityInput.value = '1';
          quantityInput.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        }
        var quantityBreaksRows = document.querySelectorAll('[data-quantity-breaks-row]');
        var quantityBreaksQuantityFirstRow = quantityBreaksRows[0];
        var firstRowInput = quantityBreaksQuantityFirstRow === null || quantityBreaksQuantityFirstRow === void 0 ? void 0 : quantityBreaksQuantityFirstRow.querySelector('input');
        if (firstRowInput) {
          firstRowInput.checked = true;
          firstRowInput.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        }
        if (window.globals && window.globals.updateQuickFacts && this.originalPrices && this.originalPrices.price) {
          window.globals.updateQuickFacts(1, {
            price_per_unit_raw: this.originalPrices.price
          });
        }
      }
    }, {
      key: "handleVariantClick",
      value: function handleVariantClick(event) {
        var clickedItem = event.currentTarget;
        this.setActiveVariant(clickedItem);
      }
    }, {
      key: "setActiveVariant",
      value: function setActiveVariant(item) {
        var variantType = item.getAttribute('data-variants-item');
        var currentVariantType = this.getAttribute('data-active-variant');
        if (currentVariantType === variantType) {
          return;
        }
        this.variantItems.forEach(function (variantItem) {
          variantItem.classList.remove('active');
        });
        item.classList.add('active');
        this.setAttribute('data-active-variant', variantType);
        if (this.mainProductSubscriptionAvailabilityContainer) {
          this.mainProductSubscriptionAvailabilityContainer.classList.toggle("!hidden", variantType === 'one_time');
        }
        if (this.mainProductOneTimeAvailabilityContainer) {
          this.mainProductOneTimeAvailabilityContainer.classList.toggle("!hidden", variantType === 'subscription');
        }
        this.toggleQuantityInputVisibility(variantType);
        this.resetQuantityInput();
        if (variantType === 'one_time') {
          this.resetToOriginalPrices();
        }
        this.dispatchEvent(new CustomEvent('purchase-widget-variant-changed', {
          detail: {
            variantType: variantType
          },
          bubbles: true
        }));
      }
    }, {
      key: "updateIntelligemsPrice",
      value: function updateIntelligemsPrice() {
        var _this$originalPrices$, _this$originalPrices;
        if (!this.productId || !this.originalPrices) return;
        var intelliGemsPrice = getIntelligemsPrice(this.productId);
        if (!intelliGemsPrice) return;
        var currentVariantType = this.getAttribute('data-active-variant');
        var wasPriceInCents = (_this$originalPrices$ = (_this$originalPrices = this.originalPrices) === null || _this$originalPrices === void 0 ? void 0 : _this$originalPrices.wasPriceRaw) !== null && _this$originalPrices$ !== void 0 ? _this$originalPrices$ : null;
        var formattedCurrent = Shopify.formatMoney(intelliGemsPrice);
        var formattedWas = typeof wasPriceInCents === 'number' && wasPriceInCents > intelliGemsPrice ? Shopify.formatMoney(wasPriceInCents) : '';
        this.originalPrices.price = intelliGemsPrice;
        this.originalPrices.currentPrice = formattedCurrent;
        this.originalPrices.currentPriceText = formattedCurrent;
        this.originalPrices.wasPrice = formattedWas;
        this.originalPrices.wasPriceText = formattedWas;
        this.originalPrices.discountElementHidden = !formattedWas;
        this.originalPrices.discountPercent = formattedWas ? Math.round((wasPriceInCents - intelliGemsPrice) / wasPriceInCents * 100).toString() : '0';
        this.originalPrices.discountValue = formattedWas ? Shopify.formatMoney(wasPriceInCents - intelliGemsPrice) : '';
        if (currentVariantType === 'one_time') {
          this.resetToOriginalPrices();
        }
      }
    }]);
  }(_purchase_widget_wrapNativeSuper(HTMLElement));
  customElements.define('sga-purchase-widget', SgaPurchaseWidget);
}
;// ./js/theme.js



















}();
/******/ })()
;